export const micro_qualifications = [
    {
        id: 1,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "Python Developer",
            nameKz: "Python Developer",
            nameEng: "Python Developer"
        },
        partnerOrg: {
            nameRu: "Дирекция «Академия инфокоммуникационных технологий» — филиала АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ филиалы — «Инфокоммуникациялық технологиялар академиясы» дирекциясы",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: "9",
        regNumber: "MCCE-2022/0001",
        regDate: "10.07.2022",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Приобретение навыков программирования на языке Python — одном из наиболее популярных современных языков программирования, который широко используется в анализе данных. Python с его библиотеками является универсальным инструментом и позволяет решать много прикладных задач — от автоматизированного сбора информации и заполнения документов до анализа данных.",
            nameKz: "Python тілінде бағдарламалау дағдыларын игеру — деректерді талдауда кеңінен қолданылатын ең танымал заманауи бағдарламалау тілдерінің бірі. Кітапханалары бар Python әмбебап құрал болып табылады және автоматтандырылған ақпарат жинау мен құжаттарды толтырудан бастап деректерді талдауға дейінгі көптеген қолданбалы тапсырмаларды шешуге мүмкіндік береді.",
            nameEng: "Acquisition of programming skills in Python — one of the most popular modern programming languages, which is widely used in data analysis. Python with its libraries is a universal tool and allows you to solve many applied tasks — from automated information collection and document filling to data analysis."
        },
        goalEPMQ: {
            nameRu: "Развитие навыков программирования на языке Python, представления о сборе, обработке и анализе данных в интерактивной среде Jupyter, введение в автоматизированные методы работы с данными — машинное обучение и нейронные сети.",
            nameKz: "Python бағдарламалау дағдыларын дамыту, Jupyter интерактивті ортасында деректерді жинау, өңдеу және талдау идеялары, деректермен жұмыс істеудің автоматтандырылған әдістеріне кіріспе — машиналық оқыту және нейрондық желілер.",
            nameEng: "development of Python programming skills, understanding of data collection, processing and analysis in the Jupyter interactive environment, introduction to automated methods of working with data – machine learning and neural networks."
        },
        tasksEPMQ: [
            {
                nameRu: "изучение Python как мультипарадигменного языкового средства, достаточно полно отражающего современные концепции разработки ПО;",
                nameKz: "Python-ды мультипарадигмалық тілдік құрал ретінде зерттеу, бағдарламалық жасақтаманы әзірлеудің заманауи тұжырымдамаларын толық көрсету;",
                nameEng: "learning Python as a multi-paradigm language tool that fully reflects modern software development concepts;"
            },
            {
                nameRu: "формирование навыков создания приложений на языке Python;",
                nameKz: "Python тілінде қосымшаларды құру дағдыларын қалыптастыру;",
                nameEng: "formation of skills for creating applications in Python;"
            },
            {
                nameRu: "совершенствование и углубление навыков объектно-ориентированного и функционального программирования;",
                nameKz: "объектіге бағытталған және функционалды бағдарламалау дағдыларын жетілдіру және тереңдету;",
                nameEng: "improving and deepening the skills of object-oriented and functional programming;"
            },
            {
                nameRu: "знакомство с основами создания приложений для взаимодействия с базами данных.",
                nameKz: "мәліметтер базасымен өзара әрекеттесу үшін қосымшаларды құру негіздерімен танысу.",
                nameEng: "introduction to the basics of creating applications for interacting with databases."
            },
        ],
        formLearnResult: [
            {
                nameRu: "владеть навыками создания собственных модулей и библиотек, разработанных на языке Python.",
                nameKz: "Python тілінде жасалған жеке модульдер мен кітапханаларды жасау дағдыларын меңгеру.",
                nameEng: "Have the skills to create your own modules and libraries developed in Python."
            },
            {
                nameRu: "понимать чужой код и адаптировать его под свои задачи.",
                nameKz: "біреудің кодын түсіну және оны өз міндеттеріне бейімдеу.",
                nameEng: "understand someone else’s code and adapt it to your tasks."
            },
            {
                nameRu: "использовать настоящую среду программирования Jupyter Notebook в рабочих задачах.",
                nameKz: "жұмыс тапсырмаларында нақты Jupiter Notebook бағдарламалау ортасын пайдалану.",
                nameEng: "Use the real Jupiter Notebook programming environment in work tasks."
            },
            {
                nameRu: "автоматизировать повторяющиеся задачи работы с данными с помощью функций.",
                nameKz: "функциялар арқылы деректермен жұмыс істеудің қайталанатын тапсырмаларын автоматтандыру.",
                nameEng: "Automate repetitive tasks of working with data using functions."
            },
            {
                nameRu: "использовать библиотеку pandas для первичного изучения данных.",
                nameKz: "деректерді бастапқы зерттеу үшін pandas кітапханасын пайдалану.",
                nameEng: "Use the pandas library for primary data study."
            },
            {
                nameRu: "строить в Python графики, учитывая задачи, которые они выполняют.",
                nameKz: "Python-да орындайтын тапсырмаларды ескере отырып графиктер құру.",
                nameEng: "Build graphs in Python, taking into account the tasks they perform."
            },
            {
                nameRu: "анализировать данные АБ-тестов и подводить их итоги; обрабатывать огромные массивы данных.",
                nameKz: "АБ-тест деректерін талдау және оларды қорытындылау; деректердің үлкен массивтерін өңдеу.",
                nameEng: "Analyze AB-test data and summarize their results; process huge amounts of data."
            },
            {
                nameRu: "строить предиктивные модели.",
                nameKz: "болжалды модельдер құру.",
                nameEng: "Build predictive models."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Основы программирования на Python",
                    nameKz: "Python-да бағдарламалаудың негіздері",
                    nameEng: "Basics of Python Programming"
                },
                desc: {
                    nameRu: "Курс предназначен для изучения объектно-ориентированного программирования на языке Python. Обучающиеся изучат принципы объектно-ориентированного программирования, дополнительные элементы языка Python (классы, объекты, шаблоны и т.д.), получат понятийный аппарат объектно-ориентированного программирования (полиморфизм, инкапсуляция, наследование, конструктор и т.д.), сформируют понимание принципа повторного использования кода в программирование.",
                    nameKz: "Курс Python тілінде объектіге бағытталған бағдарламалауды үйренуге арналған. Білім алушылар объектіге бағытталған бағдарламалау принциптерін, Python тілінің қосымша элементтерін (сыныптар, объектілер, шаблондар және т.б.) зерттейді, объектіге бағытталған бағдарламалаудың тұжырымдамалық аппаратын алады (полиморфизм, инкапсуляция, мұрагерлік, конструктор және т. б.), кодты қайта пайдалану принципін түсінуді қалыптастырады. бағдарламалау.",
                    nameEng: "The course is designed to study object-oriented programming in Python. Students will learn the principles of object-oriented programming, additional elements of the Python language (classes, objects, templates, etc.), will receive the conceptual apparatus of object-oriented programming (polymorphism, encapsulation, inheritance, constructor, etc.), will form an understanding of the principle of code reuse in programming."
                },
                creditNum: 4,
                acaHrNum: 120,
                codes: 'ПК1, ПК2, ПК3, ПК6'
            },
            {
                name: {
                    nameRu: "Обработка и анализ данных на Python",
                    nameKz: "Python-да деректерді өңдеу және талдау",
                    nameEng: "Python data processing and analysis"
                },
                desc: {
                    nameRu: "Дисциплина направлена на обучение обучающихся очищать данные, собирать их и предоставлять результаты для эффективной коммуникации, используя современные графические возможности Python. В рамках этой дисциплины изучаются такие темы, как основы синтаксиса языка Python, стандартная библиотека, а также широко распространенные средства управления и визуализации данных. Данные средства используются в примерах с реальными данными.",
                    nameKz: "Пән білім алушыларды деректерді тазартуға, оларды жинауға және Python-ның заманауи графикалық мүмкіндіктерін пайдалана отырып, тиімді байланыс үшін нәтижелер беруге үйретуге бағытталған. Бұл пән Python тілінің синтаксисінің негіздері, стандартты кітапхана және деректерді басқару мен визуализацияның кең таралған құралдары сияқты тақырыптарды зерттейді. Бұл құралдар нақты деректері бар мысалдарда қолданылады.",
                    nameEng: "The discipline is aimed at teaching students to clean up data, collect it and provide results for effective communication using modern Python graphical capabilities. Within the framework of this discipline, topics such as the basics of Python syntax, the standard library, as well as widespread data management and visualization tools are studied. These tools are used in examples with real data."
                },
                creditNum: 4,
                acaHrNum: 120,
                codes: 'ПК2, ПК4, ПК5, ПК6'
            },
            {
                name: {
                    nameRu: "Итоговая аттестация",
                    nameKz: "Қорытынды аттестациялау",
                    nameEng: "Final certification"
                },
                desc: {
                    nameRu: "Целью итоговой аттестации обучающегося является оценка результатов обучения и профессиональных компетенций, достигнутых по завершению изучения образовательной программы микроквалификации",
                    nameKz: "Білім алушыны қорытынды аттестаттаудың мақсаты микроквалификацияның білім беру бағдарламасын зерделеу аяқталғаннан кейін қол жеткізілген Оқыту нәтижелері мен кәсіби құзыреттіліктерді бағалау болып табылады",
                    nameEng: "The purpose of the final certification of the student is to evaluate the results of training and professional competencies achieved upon completion of the study of the educational program of microqualification"
                },
                creditNum: 1,
                acaHrNum: 30,
                codes: ''
            }
        ]
    },
    {
        id: 2,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "Statistics Essentials",
            nameKz: "Statistics Essentials",
            nameEng: "Statistics Essentials"
        },
        partnerOrg: {
            nameRu: "Дирекция «Академия инфокоммуникационных технологий» — филиала АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ филиалы — «Инфокоммуникациялық технологиялар академиясы» дирекциясы",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 9,
        regNumber: "MCCE-2022/0002",
        regDate: "10.07.2022",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Программа направлена на подготовку специалистов по моделированию производственных процессов на основе математической статистики и анализа данных, имеющих прочные фундаментальные знания математики и в прикладных методах, основанных на вычислительных технологиях.",
            nameKz: "Бағдарлама Математика және есептеу технологияларына негізделген қолданбалы әдістер туралы берік іргелі білімі бар математикалық статистика мен деректерді талдау негізінде өндірістік процестерді модельдеу бойынша мамандарды даярлауға бағытталған.",
            nameEng: "The program is aimed at training specialists in modeling production processes based on mathematical statistics and data analysis, who have solid fundamental knowledge of mathematics and applied methods based on computational technologies."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков у обучающихся правильного применения методов математической статистики к различным прикладным задачам, а также предоставление обучающимся полноценный комплекс знаний по статистике, необходимых для успешного применения мощного инструмента статистического анализа.",
            nameKz: "Білім алушылардың әртүрлі қолданбалы есептерге математикалық статистика әдістерін дұрыс қолдану дағдыларын қалыптастыру, сондай-ақ білім алушыларға статистикалық талдаудың қуатты құралын табысты қолдану үшін қажетті статистика бойынша білімнің толыққанды кешенін ұсыну.",
            nameEng: "Formation of students’ skills in the correct application of mathematical statistics methods to various applied tasks, as well as providing students with a full-fledged set of statistical knowledge necessary for the successful application of a powerful statistical analysis tool."
        },
        tasksEPMQ: [
            {
                nameRu: "сформировать у обучающихся целостное представление о принципах математической статистики и анализа;",
                nameKz: "білім алушыларда математикалық статистика және талдау принциптері туралы тұтас түсінік қалыптастыру;",
                nameEng: "to form a holistic understanding of the principles of mathematical statistics and analysis among students;"
            },
            {
                nameRu: "привить навыки сознательного и рационального использования современных инструментальных программных средств в профессиональной деятельности для решения конкретных задач.",
                nameKz: "нақты міндеттерді шешу үшін кәсіби қызметте заманауи аспаптық бағдарламалық құралдарды саналы және ұтымды пайдалану дағдыларын қалыптастыру.",
                nameEng: "to instill the skills of conscious and rational use of modern software tools in professional activities to solve specific tasks."
            }
        ],
        formLearnResult: [
            {
                nameRu: "знать методы анализа, систематизации, представления и обобщения данных путем применения комплекса методов при решении конкретных задач;",
                nameKz: "нақты мәселелерді шешуде әдістер кешенін қолдану арқылы деректерді талдау, жүйелеу, ұсыну және жалпылау әдістерін білу;",
                nameEng: "Know the methods of analysis, systematization, presentation and generalization of data by applying a set of methods in solving specific tasks;"
            },
            {
                nameRu: "использовать статистические методы для решения конкретных задач;",
                nameKz: "нақты есептерді шешу үшін статистикалық әдістерді қолдану;",
                nameEng: "Use statistical methods to solve specific problems;"
            },
            {
                nameRu: "уметь грамотно и корректно подготавливать данные для статистического анализа;",
                nameKz: "статистикалық талдау үшін деректерді сауатты және дұрыс дайындай білу;",
                nameEng: "Be able to competently and correctly prepare data for statistical analysis;"
            },
            {
                nameRu: "владеть навыками выбора и использования методов статистической обработки и анализа данных;",
                nameKz: "статистикалық өңдеу әдістерін таңдау және пайдалану дағдыларын меңгеру және деректерді талдау;",
                nameEng: "Have the skills to choose and use methods of statistical processing and data analysis;"
            },
            {
                nameRu: "владеть технологиями анализа и статистической обработки данных с использованием пакетов прикладных программ MS Excel и Wolfram Mathematica.",
                nameKz: "MS Excel және Wolfram Mathematica қолданбалы бағдарламалық пакеттерін пайдалана отырып, деректерді талдау және статистикалық өңдеу технологияларын меңгеру.",
                nameEng: "Possess technologies of analysis and statistical data processing using MS Excel and Wolfram Mathematica application software packages."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Математическая статистика",
                    nameKz: "Математикалық статистика",
                    nameEng: "Mathematical statistics"
                },
                desc: {
                    nameRu: "Дисциплина направлена на обучение изучения закономерностей случайных явлений и их свойств, и использовать их для анализа данных. В результате изучения данной дисциплины обучающиеся будут знать основные понятия теории вероятностей и математической статистики и их свойства, а также уметь использовать вероятностные модели при решении задач, работать со случайными величинами, выполнять расчет выборочных характеристик, оценивать надежность статистических данных.",
                    nameKz: "Пән кездейсоқ құбылыстардың заңдылықтарын және олардың қасиеттерін зерттеуге және оларды деректерді талдау үшін пайдалануға үйретуге бағытталған. Осы пәнді оқу нәтижесінде студенттер Ықтималдықтар теориясы мен математикалық статистиканың негізгі ұғымдарын және олардың қасиеттерін біледі, сонымен қатар есептерді шешуде ықтималдық модельдерін қолдана алады, кездейсоқ шамалармен жұмыс істейді, таңдамалы сипаттамаларды есептейді, статистикалық мәліметтердің сенімділігін бағалайды.",
                    nameEng: "The discipline is aimed at teaching the study of the laws of random phenomena and their properties, and use them for data analysis. As a result of studying this discipline, students will know the basic concepts of probability theory and mathematical statistics and their properties, as well as be able to use probabilistic models when solving problems, work with random variables, calculate sample characteristics, evaluate the reliability of statistical data."
                },
                creditNum: 4,
                acaHrNum: 120,
                codes: "ПК1, ПК2, ПК5"
            },
            {
                name: {
                    nameRu: "Статистика для анализа данных",
                    nameKz: "Деректер талдау үшін статистика",
                    nameEng: "Statistics for data analysis"
                },
                desc: {
                    nameRu: "Дисциплина направлена на изучение методов анализа данных для количественной оценки социально-экономической ситуации на микро, макро и глобальном уровнях; проведения статистического анализа.",
                    nameKz: "Пән микро, макро және жаһандық деңгейлердегі әлеуметтік-экономикалық жағдайды сандық бағалау үшін деректерді талдау әдістерін зерттеуге; статистикалық талдау жүргізуге бағытталған.",
                    nameEng: "The discipline is aimed at studying data analysis methods for quantitative assessment of the socio-economic situation at the micro, macro and global levels; conducting statistical analysis."
                },
                creditNum: 4,
                acaHrNum: 120,
                codes: "ПК3, ПК4, ПК5"
            },
            {
                name: {
                    nameRu: "Итоговая аттестация",
                    nameKz: "Қорытынды аттестациялау",
                    nameEng: "Final certification"
                },
                desc: {
                    nameRu: "Целью итоговой аттестации обучающегося является оценка результатов обучения и профессиональных компетенций, достигнутых по завершению изучения образовательной программы микроквалификации",
                    nameKz: "Білім алушыны қорытынды аттестаттаудың мақсаты микроквалификацияның білім беру бағдарламасын зерделеу аяқталғаннан кейін қол жеткізілген Оқыту нәтижелері мен кәсіби құзыреттіліктерді бағалау болып табылады",
                    nameEng: "The purpose of the final certification of the student is to evaluate the results of training and professional competencies achieved upon completion of the study of the educational program of microqualification"
                },
                creditNum: 1,
                acaHrNum: 30,
                codes: ''
            }
        ]
    },
    {
        id: 3,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "ML Specialist",
            nameKz: "ML Specialist",
            nameEng: "ML Specialist"
        },
        partnerOrg: {
            nameRu: "Дирекция «Академия инфокоммуникационных технологий» — филиала АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ филиалы — «Инфокоммуникациялық технологиялар академиясы» дирекциясы",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0003",
        regDate: "10.07.2022",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Программа направлена на подготовку специалистов в области машинного обучения и анализа больших данных, на получение компетенций, необходимых для выполнения нового вида профессиональной деятельности — умения применять языки программирования SQL и Python для сбора, визуализации, анализа больших данных (Big data) и построение моделей машинного обучения, умения применять конкретные аналитические и продуктовые подходы.",
            nameKz: "Бағдарлама Машиналық оқыту және үлкен деректерді талдау саласындағы мамандарды даярлауға, кәсіби қызметтің жаңа түрін — үлкен деректерді жинау, визуализациялау, талдау (Big data) үшін SQL және Python бағдарламалау тілдерін қолдана білуге және машиналық оқыту модельдерін құруға, нақты аналитикалық және өнімдік тәсілдерді қолдана білуге бағытталған.",
            nameEng: "The program is aimed at training specialists in the field of machine learning and big data analysis, at obtaining the competencies necessary to perform a new type of professional activity – the ability to use the SQL and Python programming languages for collecting, visualizing, analyzing big data (Big data) and building machine learning models, the ability to apply specific analytical and product approaches."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков у обучающихся анализа задач машинного обучения и взвешенного выбора того или иного решения по работам с большими данными.",
            nameKz: "Білім алушыларда Машиналық оқыту міндеттерін талдау және үлкен деректермен жұмыс істеу бойынша қандай да бір шешімді салмақты таңдау дағдыларын қалыптастыру.",
            nameEng: "Formation of students’ skills in analyzing machine learning tasks and making a balanced choice of a particular solution for working with big data."
        },
        tasksEPMQ: [
            {
                nameRu: "воспитание информационной, технической и исследовательской культуры;",
                nameKz: "ақпараттық, техникалық және зерттеу мәдениетін тәрбиелеу;",
                nameEng: "education of information, technical and research culture;"
            },
            {
                nameRu: "развитие интереса к научно-техническому творчеству, технике, высоким технологиям;",
                nameKz: "ғылыми-техникалық шығармашылыққа, техникаға, жоғары технологияларға қызығушылықты дамыту;",
                nameEng: "development of interest in scientific and technical creativity, technology, high technologies;"
            },
            {
                nameRu: "развитие алгоритмического и логического мышления;",
                nameKz: "алгоритмдік және логикалық ойлауды дамыту;",
                nameEng: "development of algorithmic and logical thinking;"
            },
            {
                nameRu: "сформировать теоретические знания по основам машинного обучения для построения формальных математических моделей и интерпретации результатов моделирования;",
                nameKz: "формальды математикалық модельдерді құру және модельдеу нәтижелерін түсіндіру үшін машиналық оқыту негіздері бойынша теориялық білім қалыптастыру;",
                nameEng: "to form theoretical knowledge on the basics of machine learning for the construction of formal mathematical models and interpretation of simulation results;"
            },
            {
                nameRu: "выработать умения по практическому применению методов машинного обучения при решении прикладных задач в различных областях;",
                nameKz: "әртүрлі салалардағы қолданбалы есептерді шешуде Машиналық оқыту әдістерін практикалық қолдану бойынша дағдыларды дамыту;",
                nameEng: "develop skills for the practical application of machine learning methods in solving applied problems in various fields;"
            },
            {
                nameRu: "выработать умения и навыки использования библиотек языка Python для разработки систем машинного обучения.",
                nameKz: "Машиналық оқыту жүйелерін әзірлеу үшін Python тіл кітапханаларын пайдалану дағдылары мен дағдыларын дамыту.",
                nameEng: "to develop skills and abilities of using Python libraries for the development of machine learning systems."
            }
        ],
        formLearnResult: [
            {
                nameRu: "правильно выбирать данные и переводить их в понятный машине формат;",
                nameKz: "деректерді дұрыс таңдап оны машинада түсінікті форматқа аудару;",
                nameEng: "choose the right data and translate it into a format understandable to the machine;"
            },
            {
                nameRu: "проектировать и обучать нейронные сети и другие модели машинного обучения;",
                nameKz: "нейрондық желілерді және машиналық оқытудың басқа модельдерін жобалау және оқыту;",
                nameEng: "design and train neural networks and other machine learning models;"
            },
            {
                nameRu: "оценивать, насколько хорошо нейронные сети справляются со своими задачами;",
                nameKz: "нейрондық желілердің өз міндеттерін қаншалықты жақсы орындайтынын бағалау;",
                nameEng: "evaluate how well neural networks cope with their tasks;"
            },
            {
                nameRu: "пользоваться фреймворком PyTorch, библиотекой Tensorflow и Keras API;",
                nameKz: "PyTorch шеңберін, TensorFlow кітапханасын және keras API пайдалану;",
                nameEng: "use the PyTorch framework, Tensorflow library and Keras API;"
            },
            {
                nameRu: "использовать имеющиеся знания для решения практических задач глубокого обучения;",
                nameKz: "терең оқытудың практикалық мәселелерін шешу үшін қолда бар білімді пайдалану;",
                nameEng: "use existing knowledge to solve practical problems of deep learning;"
            },
            {
                nameRu: "ориентироваться в понятиях мира Больших Данных, Машинного обучения и Интернета Вещей;",
                nameKz: "үлкен деректер әлемі, Машиналық оқыту және Заттар интернеті ұғымдарын басшылыққа алу;",
                nameEng: "navigate the concepts of the world of Big Data, Machine Learning and the Internet of Things;"
            },
            {
                nameRu: "знать отличия разных версий дистрибутивов Hadoop, Spark, NoSQL или Kafka;",
                nameKz: "Hadoop, Spark, NoSQL немесе Kafka дистрибутивтерінің әртүрлі нұсқаларының айырмашылықтарын білу;",
                nameEng: "know the differences between different versions of Hadoop, Spark, NoSQL or Kafka distributions;"
            },
            {
                nameRu: "определять нюансы облачных решений;",
                nameKz: "бұлтты шешімдердің нюанстарын анықтау;",
                nameEng: "identify the nuances of cloud solutions;"
            },
            {
                nameRu: "знать, что такое стандарт GDPR;",
                nameKz: "GMP стандартының не екенін білу;",
                nameEng: "Know what the GMP standard is;"
            },
            {
                nameRu: "определять особенности Индустриального интернета Вещей.",
                nameKz: "заттардың индустриялық интернетінің ерекшеліктерін анықтау.",
                nameEng: "determine the features of the Industrial Internet of Things."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Цифровая трансформация компании",
                    nameKz: "Компанияның цифрлық трансформациясы",
                    nameEng: "Digital transformation of the company"
                },
                desc: {
                    nameRu: "Дисциплина посвящена обсуждению изменений в компаниях, происходящих под влиянием появляющихся новых информационных технологий. Рассматривается изменение среды бизнеса, появление новых моделей и сценариев в современной среде. Особое внимание уделяется трансформации бизнес-моделей, влиянию эволюции цифровых технологий на персонал компаний, изменению характера конкуренции. В ходе курса рассматриваются мировые тренды и особенности эволюции бизнеса в Казахстане.",
                    nameKz: "Пән жаңа ақпараттық технологиялардың әсерінен болатын компаниялардағы өзгерістерді талқылауға арналған. Бизнес ортасының өзгеруі, қазіргі ортада жаңа модельдер мен сценарийлердің пайда болуы қарастырылады. Бизнес-модельдердің трансформациясына, цифрлық технологиялар эволюциясының компания персоналына әсеріне, бәсекелестік сипатының өзгеруіне ерекше назар аударылады. Курс барысында Қазақстандағы бизнес эволюциясының әлемдік трендтері мен ерекшеліктері қарастырылады.",
                    nameEng: "The discipline is devoted to discussing changes in companies that occur under the influence of emerging new information technologies. The article considers the change in the business environment, the emergence of new models and scenarios in the modern environment. Particular attention is paid to the transformation of business models, the impact of the evolution of digital technologies on the personnel of companies, the changing nature of competition. The course examines global trends and features of the evolution of business in Kazakhstan."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК5"
            },
            {
                name: {
                    nameRu: "Управление проектами в цифровом бизнесе",
                    nameKz: "Цифрлық бизнестегі жобаларды басқару",
                    nameEng: "Project management in digital business"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у слушателей профессиональных компетенций, необходимых для управления государственными и коммерческими Интернет-проектами с применением современных цифровых технологий и инструментальных средств. Проводится обучение работе в CMS-системе: управление сайтом, создавние и редактирование контента, настройка страниц, структуры и отдельных блоков сайта. Программа представляет собой системный взгляд на цифровой бизнес и цифровую экономику и имеет практическую направленность.",
                    nameKz: "Пәннің мақсаты тыңдаушыларда заманауи цифрлық технологиялар мен аспаптық құралдарды қолдана отырып, мемлекеттік және коммерциялық Интернет-жобаларды басқару үшін қажетті кәсіби құзыреттіліктерді қалыптастыру болып табылады. CMS жүйесінде жұмыс істеуге оқыту жүргізіледі: сайтты басқару, мазмұнды құру және редакциялау, беттерді, құрылымды және сайттың жеке блоктарын теңшеу. Бағдарлама Цифрлық бизнес пен цифрлық экономикаға жүйелі көзқарас болып табылады және практикалық бағытқа ие.",
                    nameEng: "The purpose of the discipline is to form students’ professional competencies necessary for the management of government and commercial Internet projects using modern digital technologies and tools. Training is provided to work in the CMS system: site management, content creation and editing, setting up pages, structure and individual blocks of the site. The program is a systematic view of digital business and the digital economy and has a practical focus."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3, ПК4"
            },
            {
                name: {
                    nameRu: "Создание и развитие цифровых продуктов",
                    nameKz: "Сандық өнімдерді құру және дамыту",
                    nameEng: "Creation and development of digital products"
                },
                desc: {
                    nameRu: "Дисциплина позволит слушателям узнать, как выявить новые и востребованные рынком клиентские истории, оценить экономический эффект, преобразовать идею в конкретное решение и определить наиболее оптимальный подход к ее реализации. Знакомство с основными подходами к продуктовой аналитике и пользовательским исследованиям позволит сохранить конкурентное преимущество при дальнейшем развитии продукта.",
                    nameKz: "Пән тыңдаушыларға нарықтың жаңа және сұранысқа ие клиенттік оқиғаларын қалай анықтауға, экономикалық әсерді бағалауға, идеяны нақты шешімге айналдыруға және оны жүзеге асырудың ең оңтайлы тәсілін анықтауға мүмкіндік береді. Өнім аналитикасы мен пайдаланушыларды зерттеудің негізгі тәсілдерімен танысу өнімді одан әрі дамыту кезінде бәсекелестік артықшылықты сақтауға мүмкіндік береді.",
                    nameEng: "The discipline will allow students to learn how to identify new customer stories that are in demand by the market, evaluate the economic effect, transform an idea into a concrete solution and determine the most optimal approach to its implementation. Familiarity with the basic approaches to product analytics and user research will allow you to maintain a competitive advantage in the further development of the product."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1. ПК2, ПК3, ПК4"
            },

        ]
    },
    {
        id: 4,
        educationField: {
            nameRu: "Бизнес, управление и право",
            nameKz: "Бизнес, басқару және құқық",
            nameEng: "Business, Management and Law",
            code: ""
        },
        trainingDirection: {
            nameRu: "Бизнес и управление",
            nameKz: "Бизнес және басқару",
            nameEng: "Business and Management",
            code: ""
        },
        groupEP: {
            nameRu: "Менеджмент и управление",
            nameKz: "Менеджмент және басқару",
            nameEng: "Management and Management",
            code: ""
        },
        microQEP: {
            nameRu: "IT-аналитик",
            nameKz: "IT-талдаушы",
            nameEng: "IT-analyst"
        },
        partnerOrg: {
            nameRu: "«Корпоративный университет» — филиал АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ Корпоративтік университеті",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0004",
        regDate: "04.01.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение ключевых инструментов, методов и технологий, которые позволят структурировать управленческую задачу и выработать оптимальное решение в ситуации, связанные с рисками и неопределенность, а также изучить основы цифровизации и организационных преобразований, которые она вызывает; изучение технологических тенденций и изменений.",
            nameKz: "басқару міндетін құрылымдауға және тәуекелдер мен белгісіздікке байланысты жағдайларда оңтайлы шешім қабылдауға мүмкіндік беретін негізгі құралдарды, әдістер мен технологияларды игеру, сондай-ақ ол тудыратын цифрландыру және ұйымдастырушылық қайта құру негіздерін зерттеу; технологиялық тенденциялар мен өзгерістерді зерттеу.",
            nameEng: "the development of key tools, methods and technologies that will allow you to structure a management task and develop an optimal solution in a situation associated with risks and uncertainty, as well as to study the basics of digitalization and organizational transformations that it causes; the study of technological trends and changes."
        },
        goalEPMQ: {
            nameRu: "развитие глобального системного бизнес-мышления в рамках цифровой трансформации.",
            nameKz: "цифрлық трансформация шеңберінде жаһандық жүйелік бизнес-ойлауды дамыту.",
            nameEng: "to develop global systemic business thinking within the framework of digital transformation."
        },
        tasksEPMQ: [
            {
                nameRu: "систематизировать и обогатить предшествующий практический опыт;",
                nameKz: "алдыңғы тәжірибелік тәжірибені жүйелеу және байыту;",
                nameEng: "systematize and enrich previous practical experience;"
            },
            {
                nameRu: "развить у слушателей стратегическое мышление, предпринимательские навыки, инновационность и лидерские качества;",
                nameKz: "тыңдаушыларда стратегиялық ойлауды, кәсіпкерлік дағдыларды, инновация мен көшбасшылық қасиеттерді дамыту;",
                nameEng: "develop students’ strategic thinking, entrepreneurial skills, innovation and leadership qualities;"
            },
            {
                nameRu: "развить понимание и сформировать опыт в изучении ключевых проблем бизнеса, в том числе, его трансформации и глобализации, и определить потенциальный вклад бизнеса в решении этих проблем;",
                nameKz: "бизнестің негізгі мәселелерін, оның ішінде оның трансформациясы мен жаһандануын зерделеуде түсіністік пен тәжірибе қалыптастыру және осы проблемаларды шешуде Бизнестің әлеуетті үлесін анықтау;",
                nameEng: "develop an understanding and build experience in studying key business problems, including its transformation and globalization, and identify the potential contribution of business to solving these problems;"
            },
            {
                nameRu: "развить навыки межличностного взаимодействия и командной работы.",
                nameKz: "тұлғааралық қарым-қатынас және топтық жұмыс дағдыларын дамыту.",
                nameEng: "develop interpersonal interaction and teamwork skills."
            },

        ],
        formLearnResult: [
            {
                nameRu: "владеть полученными знаниями и практическим опытом в области принятия управленческих решений при цифровой трансформации;",
                nameKz: "цифрлық трансформация кезінде басқарушылық шешімдер қабылдау саласында алған білімі мен практикалық тәжірибесін меңгеру;",
                nameEng: "possess the acquired knowledge and practical experience in the field of managerial decision-making in digital transformation;"
            },
            {
                nameRu: "владеть методами анализа цифровой экономики, оценки эффективности цифровой трансформации, выявлять и анализировать проблемы цифровой безопасности.",
                nameKz: "цифрлық экономиканы талдау, цифрлық трансформацияның тиімділігін бағалау, цифрлық қауіпсіздік мәселелерін анықтау және талдау әдістерін меңгеру.",
                nameEng: "master the methods of analyzing the digital economy, evaluating the effectiveness of digital transformation, identify and analyze digital security problems."
            },
            {
                nameRu: "уметь выделять и соотносить негативные и позитивные факторы цифровой трансформации, определять степень их воздействия на макро- и микроэкономические показатели, на возможности ведения бизнеса и решение экологических проблем.",
                nameKz: "цифрлық трансформацияның теріс және оң факторларын ажырата және салыстыра білу, олардың макро — және микроэкономикалық көрсеткіштерге, бизнес жүргізу мүмкіндіктеріне және экологиялық проблемаларды шешуге әсер ету дәрежесін анықтау.",
                nameEng: "be able to identify and correlate negative and positive factors of digital transformation, determine the degree of their impact on macro- and microeconomic indicators, on business opportunities and solving environmental problems."
            },
            {
                nameRu: "владеть методами управления проектами и готовность к их реализации с использованием современного программного обеспечения.",
                nameKz: "жобаларды басқару әдістерін меңгеру және оларды заманауи бағдарламалық қамтамасыз етуді пайдалана отырып іске асыруға дайын болу.",
                nameEng: "possess project management methods and readiness for their implementation using modern software."
            },
            {
                nameRu: "уметь находить и оценивать новые рыночные возможности и формулировать бизнес-идею, работающие на рынке электронной коммерции.",
                nameKz: "жаңа нарықтық мүмкіндіктерді тауып, бағалай білу және электрондық коммерция нарығында жұмыс істейтін бизнес-идеяны тұжырымдай білу.",
                nameEng: "Be able to find and evaluate new market opportunities and formulate a business idea working in the e-commerce market."
            },
            {
                nameRu: "формировать потребительскую аудиторию и осуществление взаимодействие с потребителями; организовывать продажи в среде Интернет.",
                nameKz: "тұтынушы аудиториясын қалыптастыру және тұтынушылармен өзара әрекеттесуді жүзеге асыру; Интернет ортасында сатуды ұйымдастыру.",
                nameEng: "to form a consumer audience and interact with consumers; to organize sales in the Internet environment."
            },
            {
                nameRu: "знать о современных подходах и методах разработки новых продуктов, особенностях применениях технологий цифрового производства.",
                nameKz: "жаңа өнімдерді әзірлеудің заманауи тәсілдері мен әдістері, цифрлық өндіріс технологияларын қолданудың ерекшеліктері туралы білу.",
                nameEng: "to know about modern approaches and methods of developing new products, features of applications of digital production technologies."
            },
            {
                nameRu: "владеть навыком и умением практического использования технологий при разработке новых цифровых продуктов.",
                nameKz: "жаңа цифрлық өнімдерді әзірлеу кезінде технологияларды практикалық қолдану дағдысы мен дағдысын меңгеру.",
                nameEng: "possess the skill and ability to use technologies in the development of new digital products."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Цифровая трансформация компании",
                    nameKz: "Компанияның цифрлық трансформациясы",
                    nameEng: "Digital transformation of the company"
                },
                desc: {
                    nameRu: "Дисциплина посвящена обсуждению изменений в компаниях, происходящих под влиянием появляющихся новых информационных технологий. Рассматривается изменение среды бизнеса, появление новых моделей и сценариев в современной среде. Особое внимание уделяется трансформации бизнес-моделей, влиянию эволюции цифровых технологий на персонал компаний, изменению характера конкуренции. В ходе курса рассматриваются мировые тренды и особенности эволюции бизнеса в Казахстане.",
                    nameKz: "Пән Жаңа ақпараттық технологиялардың әсерінен болатын компаниялардағы өзгерістерді талқылауға арналған. Бизнес ортасының өзгеруі, қазіргі ортада жаңа модельдер мен сценарийлердің пайда болуы қарастырылады. Бизнес-модельдердің трансформациясына, цифрлық технологиялар эволюциясының компания персоналына әсеріне, бәсекелестік сипатының өзгеруіне ерекше назар аударылады. Курс барысында Қазақстандағы бизнес эволюциясының әлемдік трендтері мен ерекшеліктері қарастырылады.",
                    nameEng: "The discipline is devoted to discussing changes in companies that occur under the influence of emerging new information technologies. The article considers the change in the business environment, the emergence of new models and scenarios in the modern environment. Particular attention is paid to the transformation of business models, the impact of the evolution of digital technologies on the personnel of companies, the changing nature of competition. The course examines global trends and features of the evolution of business in Kazakhstan."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК5"
            },
            {
                name: {
                    nameRu: "Управление проектами в цифровом бизнесе",
                    nameKz: "Цифрлық бизнестегі жобаларды басқару",
                    nameEng: "Project management in digital business"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у слушателей профессиональных компетенций, необходимых для управления государственными и коммерческими Интернет-проектами с применением современных цифровых технологий и инструментальных средств. Проводится обучение работе в CMS-системе: управление сайтом, создавние и редактирование контента, настройка страниц, структуры и отдельных блоков сайта. Программа представляет собой системный взгляд на цифровой бизнес и цифровую экономику и имеет практическую направленность.",
                    nameKz: "Пәннің мақсаты тыңдаушыларда заманауи цифрлық технологиялар мен аспаптық құралдарды қолдана отырып, мемлекеттік және коммерциялық Интернет-жобаларды басқару үшін қажетті кәсіби құзыреттіліктерді қалыптастыру болып табылады. CMS жүйесінде жұмыс істеуге оқыту жүргізіледі: сайтты басқару, мазмұнды құру және редакциялау, беттерді, құрылымды және сайттың жеке блоктарын теңшеу. Бағдарлама Цифрлық бизнес пен цифрлық экономикаға жүйелі көзқарас болып табылады және практикалық бағытқа ие.",
                    nameEng: "The purpose of the discipline is to form students’ professional competencies necessary for the management of government and commercial Internet projects using modern digital technologies and tools. Training is provided to work in the CMS system: site management, content creation and editing, setting up pages, structure and individual blocks of the site. The program is a systematic view of digital business and the digital economy and has a practical focus."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3, ПК4"
            },
            {
                name: {
                    nameRu: "Создание и развитие цифровых продуктов",
                    nameKz: "Сандық өнімдерді құру және дамыту",
                    nameEng: "Creation and development of digital products"
                },
                desc: {
                    nameRu: "Дисциплина позволит слушателям узнать, как выявить новые и востребованные рынком клиентские истории, оценить экономический эффект, преобразовать идею в конкретное решение и определить наиболее оптимальный подход к ее реализации. Знакомство с основными подходами к продуктовой аналитике и пользовательским исследованиям позволит сохранить конкурентное преимущество при дальнейшем развитии продукта.",
                    nameKz: "Пән тыңдаушыларға нарықтың жаңа және сұранысқа ие клиенттік оқиғаларын қалай анықтауға, экономикалық әсерді бағалауға, идеяны нақты шешімге айналдыруға және оны жүзеге асырудың ең оңтайлы тәсілін анықтауға мүмкіндік береді. Өнім аналитикасы мен пайдаланушыларды зерттеудің негізгі тәсілдерімен танысу өнімді одан әрі дамыту кезінде бәсекелестік артықшылықты сақтауға мүмкіндік береді.",
                    nameEng: "The discipline will allow students to learn how to identify new customer stories that are in demand by the market, evaluate the economic effect, transform an idea into a concrete solution and determine the most optimal approach to its implementation. Familiarity with the basic approaches to product analytics and user research will allow you to maintain a competitive advantage in the further development of the product."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1. ПК2, ПК3, ПК4"
            },
        ]
    },
    {
        id: 5,
        educationField: {
            nameRu: "Бизнес, управление и право",
            nameKz: "Бизнес, басқару және құқық",
            nameEng: "Business, Management and Law",
            code: ""
        },
        trainingDirection: {
            nameRu: "Бизнес и управление",
            nameKz: "Бизнес және басқару",
            nameEng: "Business and Management",
            code: ""
        },
        groupEP: {
            nameRu: "Менеджмент и управление",
            nameKz: "Менеджмент және басқару",
            nameEng: "Management and Management",
            code: ""
        },
        microQEP: {
            nameRu: "Менеджер цифровой трансформации",
            nameKz: "Цифрлық трансформация менеджері",
            nameEng: "Digital transformation manager"
        },
        partnerOrg: {
            nameRu: "«Корпоративный университет» — филиал АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ Корпоративтік университеті",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 10,
        regNumber: "MCCE-2022/0005",
        regDate: "04.01.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение ключевых инструментов, методов и технологий, которые позволят структурировать управленческую задачу и выработать оптимальное решение в ситуации, связанные с рисками и неопределенность, а также изучить основы цифровизации и организационных преобразований, которые она вызывает; изучение технологических тенденций и изменений.",
            nameKz: "басқару міндетін құрылымдауға және тәуекелдер мен белгісіздікке байланысты жағдайларда оңтайлы шешім қабылдауға мүмкіндік беретін негізгі құралдарды, әдістер мен технологияларды игеру, сондай-ақ ол тудыратын цифрландыру және ұйымдастырушылық қайта құру негіздерін зерттеу; технологиялық тенденциялар мен өзгерістерді зерттеу.",
            nameEng: "the development of key tools, methods and technologies that will allow you to structure a management task and develop an optimal solution in a situation associated with risks and uncertainty, as well as to study the basics of digitalization and organizational transformations that it causes; the study of technological trends and changes."
        },
        goalEPMQ: {
            nameRu: "развитие глобального системного бизнес-мышления в рамках цифровой трансформации.",
            nameKz: "цифрлық трансформация шеңберінде жаһандық жүйелік бизнес-ойлауды дамыту.",
            nameEng: "to develop global systemic business thinking within the framework of digital transformation."
        },
        tasksEPMQ: [
            {
                nameRu: "систематизировать и обогатить предшествующий практический опыт;",
                nameKz: "алдыңғы тәжірибелік тәжірибені жүйелеу және байыту;",
                nameEng: "systematize and enrich previous practical experience;"
            },
            {
                nameRu: "развить у слушателей стратегическое мышление, предпринимательские навыки, инновационность и лидерские качества;",
                nameKz: "тыңдаушыларда стратегиялық ойлауды, кәсіпкерлік дағдыларды, инновация мен көшбасшылық қасиеттерді дамыту;",
                nameEng: "develop students’ strategic thinking, entrepreneurial skills, innovation and leadership qualities;"
            },
            {
                nameRu: "развить понимание и сформировать опыт в изучении ключевых проблем бизнеса, в том числе, его трансформации и глобализации, и определить потенциальный вклад бизнеса в решении этих проблем;",
                nameKz: "бизнестің негізгі мәселелерін, оның ішінде оның трансформациясы мен жаһандануын зерделеуде түсіністік пен тәжірибе қалыптастыру және осы проблемаларды шешуде Бизнестің әлеуетті үлесін анықтау;",
                nameEng: "develop an understanding and build experience in studying key business problems, including its transformation and globalization, and identify the potential contribution of business to solving these problems;"
            },
            {
                nameRu: "развить навыки межличностного взаимодействия и командной работы.",
                nameKz: "тұлғааралық қарым-қатынас және топтық жұмыс дағдыларын дамыту.",
                nameEng: "develop interpersonal interaction and teamwork skills."
            }
        ],
        formLearnResult: [
            {
                nameRu: "применять модель лидерства в управлении;",
                nameKz: "басқаруда көшбасшылық моделін қолдану;",
                nameEng: "Apply the leadership model in management;"
            },
            {
                nameRu: "уметь формировать и эффективно управлять командой, использовать инструменты системного и критического мышления при принятии решений;",
                nameKz: "команданы қалыптастыра және тиімді басқара білу, шешім қабылдауда жүйелік және сыни ойлау құралдарын қолдана білу;",
                nameEng: "be able to form and effectively manage a team, use the tools of systematic and critical thinking when making decisions;"
            },
            {
                nameRu: "уметь использовать инструменты эмоционального интеллекта при разрешении конфликтных ситуаций.",
                nameKz: "жанжалды жағдайларды шешуде эмоционалды интеллект құралдарын қолдана білу.",
                nameEng: "be able to use the tools of emotional intelligence in resolving conflict situations."
            },
            {
                nameRu: "владеть различными способами разрешения конфликтных ситуаций.",
                nameKz: "жанжалды жағдайларды шешудің әртүрлі тәсілдерін меңгеру.",
                nameEng: "own various ways to resolve conflict situations."
            },
            {
                nameRu: "Владеть навыками разработки стратегии Digital маркетинга и выбора каналов цифровых коммуникаций для выполнения задач маркетинговой стратегии.",
                nameKz: "маркетингтік стратегияның міндеттерін орындау үшін digital маркетинг стратегиясын әзірлеу және цифрлық байланыс арналарын таңдау дағдыларын меңгеру.",
                nameEng: "Have the skills to develop a Digital marketing strategy and select digital communication channels to fulfill the tasks of a marketing strategy."
            },
            {
                nameRu: "владеть навыками продвижения продукта/бренда в цифровой среде.",
                nameKz: "сандық ортада өнімді/брендті жылжыту дағдыларын меңгеру.",
                nameEng: "Have the skills to promote a product/brand in a digital environment."
            },
            {
                nameRu: "уметь организовать подготовку к переговорам и вести их при разных типах отношений; реализовывать принципы медиации.",
                nameKz: "келіссөздерге дайындықты ұйымдастыра білу және оларды қарым-қатынастың әртүрлі түрлерінде жүргізу; медиация принциптерін жүзеге асыру.",
                nameEng: "be able to organize preparation for negotiations and conduct them with different types of relationships; implement the principles of mediation."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Лидерство в современном бизнесе",
                    nameKz: "Замауи бизнестегі көшбасшылық",
                    nameEng: "Leadership in modern business"
                },
                desc: {
                    nameRu: "Дисциплина учит обучающихся принципам и основам лидерства, а также навыкам формирования, развития и совершенствования лидерских качеств в бизнесе. Дисциплина имеет практическую направленность, и выступает как инструмент освоения конкретных управленческих технологий и навыков.",
                    nameKz: "Пән білім алушыларға көшбасшылық принциптері мен негіздерін, сондай-ақ бизнестегі көшбасшылық қасиеттерді қалыптастыру, дамыту және жетілдіру дағдыларын үйретеді. Пән практикалық бағытқа ие және нақты басқару технологиялары мен дағдыларын игеру құралы ретінде әрекет етеді.",
                    nameEng: "The discipline teaches students the principles and fundamentals of leadership, as well as the skills of formation, development and improvement of leadership qualities in business. The discipline has a practical orientation, and acts as a tool for mastering specific management technologies and skills."
                },
                creditNum: 3,
                acaHrNum: 90,
                codes: "ПК 1, ПК 2, ПК 3, ПК 6"
            },
            {
                name: {
                    nameRu: "Цифровой маркетинг и бренд-менеджмент",
                    nameKz: "Цифрлық маркетинг және бренд-менеджмент",
                    nameEng: "Digital marketing and Brand management"
                },
                desc: {
                    nameRu: "Цифровой маркетинг и управление брендом – это новое сочетание технологий, маркетинга и анализа данных, которое решает ключевые маркетинговые проблемы современности. Включает в себя новые способы взаимодействия с клиентами и получение более глубоких знаний о клиентах за счет облегчения каналов онлайн-коммуникаций и лучшего удовлетворения потребностей клиентов. Этот предмет также изучает выявление моделей поведения клиентов и их анализ для достижения нового удовлетворенности клиентов и привлечения трафика на веб-сайт или приложение.",
                    nameKz: "Сандық маркетинг және брендті басқару-бұл қазіргі заманның негізгі маркетингтік мәселелерін шешетін технологияның, маркетингтің және деректерді талдаудың жаңа қоспасы. Клиенттермен қарым-қатынастың жаңа тәсілдерін және онлайн-байланыс арналарын жеңілдету және клиенттердің қажеттіліктерін қанағаттандыру арқылы клиенттер туралы терең білім алуды қамтиды. Бұл пән сонымен қатар тұтынушылардың Жаңа қанағаттануына қол жеткізу және веб-сайтқа немесе қолданбаға трафикті тарту үшін тұтынушылардың мінез-құлық үлгілерін анықтауды және оларды талдауды зерттейді.",
                    nameEng: "Digital marketing and brand management is a new combination of technology, marketing and data analysis that solves the key marketing problems of our time. It includes new ways of interacting with customers and gaining deeper knowledge about customers by facilitating online communication channels and better meeting customer needs. This subject also studies identifying customer behavior patterns and analyzing them to achieve new customer satisfaction and drive traffic to a website or application."
                },
                creditNum: 3,
                acaHrNum: 90,
                codes: "ПК 1, ПК 3, ПК 4, ПК 5, ПК 6"
            },
            {
                name: {
                    nameRu: "Технология и этика ведения переговоров",
                    nameKz: "Технология және келіссөздер этикасы",
                    nameEng: "Technology and ethics of negotiation"
                },
                desc: {
                    nameRu: "Дисциплина направлена на изучение вопросов организации и проведения различных видов переговоров, сформировать компетенции ведения переговоров в профессиональной деятельности, умение использовать новые информационные технологии в процессе организации переговорного процесса. По итогу обучения обучающиеся смогут вести результативные переговоры и презентации организации коммерческих переговоров и презентации, проводить диагностику стиля ведения переговоров собеседника и выбора конкретных тактических приемов для достижения результата, умение создавать благоприятный климат для ведения переговоров и презентаций, получат знания этических особенностей и делового этикета в процессе ведения переговоров.",
                    nameKz: "Пән келіссөздердің әртүрлі түрлерін ұйымдастыру және өткізу мәселелерін зерделеуге, кәсіби қызметте келіссөздер жүргізу құзыреттерін қалыптастыруға, келіссөздер процесін ұйымдастыру процесінде жаңа ақпараттық технологияларды қолдана білуге бағытталған. Оқыту қорытындысы бойынша білім алушылар нәтижелі келіссөздер жүргізе алады және коммерциялық келіссөздер мен презентацияларды ұйымдастыра алады, әңгімелесушінің келіссөздер жүргізу стиліне диагностика жүргізе алады және нәтижеге жету үшін нақты тактикалық әдістерді таңдай алады, келіссөздер мен презентациялар жүргізу үшін қолайлы климат жасай алады, келіссөздер жүргізу процесінде этикалық ерекшеліктер мен іскерлік этикет туралы білім алады.",
                    nameEng: "The discipline is aimed at studying the issues of organizing and conducting various types of negotiations, to form negotiation competencies in professional activities, the ability to use new information technologies in the process of organizing the negotiation process. As a result of the training, students will be able to conduct effective negotiations and presentations of the organization of commercial negotiations and presentations, diagnose the style of negotiation of the interlocutor and the choice of specific tactics to achieve results, the ability to create a favorable climate for negotiations and presentations, gain knowledge of ethical features and business etiquette in the negotiation process."
                },
                creditNum: 3,
                acaHrNum: 90,
                codes: "ПК 1, ПК 3, ПК 6"
            },
        ]
    },
    {
        id: 6,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Телекоммуникации",
            nameKz: "Телекоммуникация",
            nameEng: "Telecommunications",
            code: ""
        },
        groupEP: {
            nameRu: "Коммуникации и коммуникационные технологии",
            nameKz: "Коммуникациялар және коммуникациялық технологиялар",
            nameEng: "Communications and communication technologies",
            code: ""
        },
        microQEP: {
            nameRu: "Artificial Intelligence Specialist. Basic level",
            nameKz: "Artificial Intelligence Specialist. Basic level",
            nameEng: "Artificial Intelligence Specialist. Basic level"
        },
        partnerOrg: {
            nameRu: "Samsung Electronics Central Eurasia",
            nameKz: "Samsung Electronics Central Eurasia",
            nameEng: "Samsung Electronics Central Eurasia"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 21,
        regNumber: "MCCE-2023/0006",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение принципов организации и функционирования интеллектуальных систем с использованием методов и алгоритмов машинного обучения, в частности базового уровня при работе с роботом, а также получение практических навыков их проектирования.",
            nameKz: "Машиналық оқыту әдістері мен алгоритмдерін, атап айтқанда роботпен жұмыс істеу кезінде базалық деңгейді қолдана отырып, интеллектуалды жүйелерді ұйымдастыру және жұмыс істеу принциптерін игеру, сондай-ақ оларды жобалаудың практикалық дағдыларын алу.",
            nameEng: "mastering the principles of organization and functioning of intelligent systems using machine learning methods and algorithms, in particular the basic level when working with a robot, as well as obtaining practical skills in their design."
        },
        goalEPMQ: {
            nameRu: "Обучение современным технологиям в области искусственного интеллекта и их применения в роботизированных системах",
            nameKz: "Жасанды интеллект саласындағы заманауи технологияларды оқыту және оларды роботтық жүйелерде қолдану",
            nameEng: "Training in modern technologies in the field of artificial intelligence and their application in robotic systems"
        },
        tasksEPMQ: [
            {
                nameRu: "изучение методологии логического, функционального, объектно-ориентированного программирования на языках высокого уровня;",
                nameKz: "жоғары деңгейлі тілдерде логикалық, функционалды, объектіге бағытталған бағдарламалау әдістемесін зерттеу;",
                nameEng: "studying the methodology of logical, functional, object-oriented programming in high-level languages;"
            },
            {
                nameRu: "разрабатывать экспертные интеллектуальные системы с использованием методов машинного обучения на базе робота;",
                nameKz: "робот негізінде Машиналық оқыту әдістерін пайдалана отырып, сараптамалық зияткерлік жүйелерді әзірлеу;",
                nameEng: "develop expert intelligent systems using robot-based machine learning methods;"
            },
            {
                nameRu: "изучить нейросетевые методы проектирования в задачах искусственного интеллекта;",
                nameKz: "жасанды интеллект мәселелерінде нейрондық желіні жобалау әдістерін үйрену;",
                nameEng: "study neural network design methods in artificial intelligence problems;"
            },
            {
                nameRu: "развитие навыков работы с промышленными роботами на уровне создания интеллектуальных систем;",
                nameKz: "зияткерлік жүйелерді құру деңгейінде өнеркәсіптік роботтармен жұмыс істеу дағдыларын дамыту;",
                nameEng: "development of skills in working with industrial robots at the level of creating intelligent systems;"
            },
            {
                nameRu: "приобрести теоретические и практические знания в области искусственного интеллекта в целом и, в частности, в области создания алгоритмов, способных к обучению.",
                nameKz: "жалпы жасанды интеллект саласында, атап айтқанда, оқуға қабілетті алгоритмдерді құру саласында теориялық және практикалық білім алу.",
                nameEng: "acquire theoretical and practical knowledge in the field of artificial intelligence in general and, in particular, in the field of creating algorithms capable of learning."
            },
        ],
        formLearnResult: [
            {
                nameRu: "Уметь создавать программные продукты в области искусственного интеллекта с использованием методов машинного обучения.",
                nameKz: "Машиналық оқыту әдістерін қолдана отырып, жасанды интеллект саласында бағдарламалық өнімдерді жасай білу.",
                nameEng: "Be able to create software products in the field of artificial intelligence using machine learning methods."
            },
            {
                nameRu: "Уметь управлять интеллектуальными системами на базе роботизированных комплексов.",
                nameKz: "Роботтық кешендер негізінде интеллектуалды жүйелерді басқара білу.",
                nameEng: "Be able to manage intelligent systems based on robotic complexes."
            },
            {
                nameRu: "Уметь применять методологии современных языков программирования в работе с интеллектуальными системами с помощью нейросетевых методов.",
                nameKz: "Нейрондық желі әдістерін қолдана отырып, интеллектуалды жүйелермен жұмыс жасауда Заманауи бағдарламалау тілдерінің әдістемелерін қолдана білу.",
                nameEng: "Be able to apply the methodologies of modern programming languages when working with intelligent systems using neural network methods."
            },
            {
                nameRu: "Уметь использовать технологии искусственного интеллекта и ориентироваться в различных типах интеллектуальных систем и методах представления знаний;",
                nameKz: "Жасанды интеллект технологияларын қолдана білу және интеллектуалды жүйелердің әртүрлі түрлерін және білімді ұсыну әдістерін басшылыққа алу;",
                nameEng: "Be able to use artificial intelligence technologies and navigate various types of intelligent systems and methods of knowledge representation;"
            },
            {
                nameRu: "Уметь разрабатывать нейросетевые технологии для различных задач при работе с роботизированными устройствами.",
                nameKz: "Роботты құрылғылармен жұмыс істеу кезінде әртүрлі тапсырмалар үшін нейрондық желілік технологияларды дамыта білу.",
                nameEng: "Be able to develop neural network technologies for various tasks when working with robotic devices."
            },
            {
                nameRu: "Уметь создавать интеллектуальные системы и использовать современные программные инструменты для сбора, систематизации, обработки и представления данных.",
                nameKz: "Ақылды жүйелерді құра білу және деректерді жинау, жүйелеу, өңдеу және ұсыну үшін заманауи бағдарламалық құралдарды қолдана білу.",
                nameEng: "Be able to create intelligent systems and use modern software tools to collect, organize, process and present data."
            },
            {
                nameRu: "Уметь понимать, обрабатывать и размышлять о новых и устоявшихся результатах исследований в области искусственного интеллекта в работе с роботизированными комплексами.",
                nameKz: "Роботтық кешендермен жұмыс жасауда жасанды интеллект саласындағы зерттеулердің жаңа және қалыптасқан нәтижелерін түсіне, өңдей және ой елегінен өткізе білу.",
                nameEng: "Be able to understand, process and reflect on new and established research results in the field of artificial intelligence in working with robotic systems."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Введение в программирование (С++)",
                    nameKz: "С++-ге кіріспе",
                    nameEng: "Introduction to Programming (С++)"
                },
                desc: {
                    nameRu: "Курс предназначен для изучения основ программирования и отладки программ. Рассматриваются неформальное определение понятия алгоритм, переменные, типы данных языка С++, итеративные конструкции, ветвления в коде, получение доступа к локальным и удаленным файлам, работа с функциями на языке C++.",
                    nameKz: "Бағдарламалау және бағдарламалардың орналасуын оқу үшін курстың мақсаты. Алгоритм, айнымалылар, С++ тілінің деректер түрлері, итерациялық құрылымдар, кодта бранчдар, жергілікті және алыстағы файлдарға кіру, C++ тіліндегі функциялармен жұмыс жасау мәселелері талқыланады.",
                    nameEng: "The course is designed to learn the basics of programming and debugging programs. The informal definition of the concept of algorithm, variables, data types of the C++ language, iterative constructions, branching in the code, gaining access to local and remote files, working with functions in the C++ language are considered."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК4, ПК6"
            },
            {
                name: {
                    nameRu: "Продвинутое программирование на C/C++",
                    nameKz: "C/C++-да жетілдірілген бағдарламалау",
                    nameEng: "Advanced programming on C/C++\t"
                },
                desc: {
                    nameRu: "Изучаются алгоритмы и структуры данных в программировании на С/С++, синтаксис современного языка программирования, управляющие операторы, функции, процедуры и работа с файлами. Рассматриваются основы принципы разработки текстов программ и их трансляции в современных средах программирования. Даются принципиальные основы и навыки проектирования программ с многооконным интерфейсом, методы и способы устранения ошибок при их наличии в процессе написания алгоритмов и кодов программ. Исследуется продвинутое программирование на С/С++ с применением системного подхода многозадачности, файловая система, межпроцессорное взаимодействие и обработка ошибок.",
                    nameKz: "C/C++ тілдерінде программалауға алгоритмдер мен деректер құрылымдарын оқыту, заманауи бағдарламалау тілінің синтаксисі, басқару операторлары, функциялары, процедуралары және файлдармен жұмыс жасау. Программалардың мәтіндерін жасау және оларды қазіргі программалау орталарында таратуға үстінді арқылы алдын ала отырып, многокүрші интерфейсті бар программаларды жобалауға, алгоритмдер мен программалау кодтарын жазудың қателіктерді жою әдістері мен негіздерін беру. C/C++ тілдерінде жетілдірілген бағдарламалаудың жүйелік әдістері, файл жүйесі, процессордың арасындағы өзара әрекеттесу және қателіктерді өңдеу.",
                    nameEng: "Algorithms and data structures in C/C++ programming, the syntax of a modern programming language, control statements, functions, procedures and working with files are studied. The fundamental principles of developing program texts and their translation in modern programming environments are considered. The fundamental principles and skills of designing programs with a multi-window interface, methods and methods for eliminating errors if they exist in the process of writing algorithms and program codes are given. Explores advanced programming in C/C++ using a systematic approach to multitasking, file system, interprocessor communication and error handling."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК4, ПК6"
            },
            {
                name: {
                    nameRu: "Введение в интеллектуальные системы",
                    nameKz: "Интеллектуалды жүйелерге кіріспе",
                    nameEng: "Introduction to Intelligent Systems"
                },
                desc: {
                    nameRu: "Курс направлен на формирование у студентов представления о цифровой электронике, основах цифровой схемотехники, принципах работы и проектирования цифровых устройств. В курсе рассматриваются основные методы описания и синтеза логических схем, современные средства разработки цифровых устройств.",
                    nameKz: "Студенттердің цифрлық электроника, цифрлық схемотехника негіздері, цифрлық құрылғылардың жұмыс және дизайн принциптері туралы ой-жүйе құртынуға арналған курс. Основалық логикалық схемаларды сипаттау мен синтездеу әдістері, цифрлық құрылғыларды жасауға арналған заманауи құралдарды талдау.",
                    nameEng: "The course is aimed at developing students’ understanding of digital electronics, the basics of digital circuitry, the principles of operation and design of digital devices. The course examines the basic methods of describing and synthesizing logic circuits, modern means of developing digital devices."
                },
                creditNum: 5,
                acaHrNum: 120,
                codes: "ПК2, ПК4, ПК6"
            },
            {
                name: {
                    nameRu: "Машинное обучение",
                    nameKz: "Машиналық оқыту",
                    nameEng: "Machine learning"
                },
                desc: {
                    nameRu: "Цель курса — получить теоретические и практические знания в области искусственного интеллекта в целом, и в частности в построении алгоритмов, способных обучаться. Курс рассматривает основные алгоритмы машинного обучения, различные подходы и технологии анализа данных, их качества, особенности и влияние в различных сферах науки и техники. В результате освоения курса, обучающиеся смогут применять методы машинного обучения для визуализации своих данных, строить графики, качественно представлять результаты.",
                    nameKz: "Курстың мақсаты — жалпы жасанды интеллект саласында, алгоритмдерді құруда теориялық және практикалық білім алу. Машиналық оқыту алгоритмдерін, деректерді анализдағы әдістер мен технологиялардың негіздерін, олардың сапасын, ғылым мен техниканың әртүрлі салаларындағы өзгерістерді талдау. Курсты аяқтап, оқытушылар деректерді визуализациялау, графиктер құру, нәтижелерді сапалы ұсыну үшін машиналық оқыту әдістерін қолдана алады.",
                    nameEng: "The purpose of the course is to gain theoretical and practical knowledge in the field of artificial intelligence in general, and in particular in the construction of algorithms that can learn. The course examines the basic algorithms of machine learning, various approaches and technologies for data analysis, their qualities, features and influence in various fields of science and technology. As a result of mastering the course, students will be able to use machine learning methods to visualize their data, build graphs, and present results qualitatively."
                },
                creditNum: 5,
                acaHrNum: 120,
                codes: "ПК2, ПК4, ПК5, ПК6"
            },
        ]
    },
    {
        id: 7,
        educationField: {
            nameRu: "Инженерные, обрабатывающие и строительные отрасли",
            nameKz: "Инженерлік, өңдеу және құрылыс салалары",
            nameEng: "Engineering, manufacturing and construction industries",
            code: ""
        },
        trainingDirection: {
            nameRu: "Инженерия и инженерное дело",
            nameKz: "Инженерия және инженерлік",
            nameEng: "Engineering and engineering",
            code: ""
        },
        groupEP: {
            nameRu: "Электротехника и автоматизация",
            nameKz: "Электротехника және автоматтандыру",
            nameEng: "Electrical engineering and automation",
            code: ""
        },
        microQEP: {
            nameRu: "IoT Specialist",
            nameKz: "IoT Specialist",
            nameEng: "IoT Specialist"
        },
        partnerOrg: {
            nameRu: "Samsung Electronics Central Eurasia",
            nameKz: "Samsung Electronics Central Eurasia",
            nameEng: "Samsung Electronics Central Eurasia"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 15,
        regNumber: "MCCE-2023/0008",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "это освоение принципиальных методов и инновационных сервисов по подключенным объектам при разработки, управлении, контроле IoT-устройств, платформ, программного обеспечения, аппаратных средств и систем, а также изучение основ проектирования в современных средах программирования в создании веб сервера и взаимодействия с мобильными устройствами.",
            nameKz: "бұл IoT құрылғыларын, платформаларды, бағдарламалық жасақтаманы, аппараттық құралдар мен жүйелерді әзірлеу, басқару, бақылау кезінде қосылған объектілер бойынша принципті әдістер мен инновациялық қызметтерді игеру, сондай-ақ веб-серверді құруда және мобильді құрылғылармен өзара әрекеттесуде Заманауи бағдарламалау орталарында дизайн негіздерін зерттеу.",
            nameEng: "This is the development of fundamental methods and innovative services for connected objects in the development, management, control of IoT devices, platforms, software, hardware and systems, as well as the study of the fundamentals of design in modern programming environments in the creation of a web server and interaction with mobile devices."
        },
        goalEPMQ: {
            nameRu: "Обучение современным технологиям и сервисам в работе с IoT-устройствами на базе Samsung и развитие профессиональных центров в области Интернета вещей.",
            nameKz: "Samsung базасында IoT-құрылғылармен жұмыс істеуде заманауи технологиялар мен сервистерді оқыту және Заттар интернеті саласындағы кәсіби орталықтарды дамыту.",
            nameEng: "Training in modern technologies and services for working with Samsung-based IoT devices and development of professional centers in the field of Internet of Things."
        },
        tasksEPMQ: [
            {
                nameRu: "разрабатывать IoT-устройства на базе микроконтроллеров;",
                nameKz: "микроконтроллерлер негізінде IoT құрылғыларын әзірлеу;",
                nameEng: "develop IoT devices based on microcontrollers;"
            },
            {
                nameRu: "изучить общие принципы микроэлектроники и программирования IoT-устройств;",
                nameKz: "микроэлектроника мен IoT құрылғыларын бағдарламалаудың жалпы принциптерін зерттеу;",
                nameEng: "study the general principles of microelectronics and programming IoT devices;"
            },
            {
                nameRu: "развитие навыков работы с промышленными микроконтроллерами и интерфейсами взаимодействия между IoT-устройствами;",
                nameKz: "өнеркәсіптік микроконтроллерлермен және IOT-құрылғылар арасындағы өзара іс-қимыл интерфейстерімен жұмыс істеу дағдыларын дамыту;",
                nameEng: "development of skills in working with industrial microcontrollers and interaction interfaces between IoT devices;"
            },
            {
                nameRu: "проектирование сети компьютеров, датчиков (сенсоров) и исполнительных устройств в рамках микроквалификации;",
                nameKz: "микроквалификация шеңберінде компьютерлер, датчиктер (датчиктер) және атқарушы құрылғылар желісін жобалау;",
                nameEng: "designing a network of computers, sensors (sensors) and actuators within the framework of microqualification;"
            },
            {
                nameRu: "изучить архитектуры существующих IoT-решений и программно-аппаратных комплексов в автоматизации промышленного Интернета вещей.",
                nameKz: "заттардың өнеркәсіптік интернетін автоматтандыруда қолданыстағы IoT шешімдері мен бағдарламалық-аппараттық кешендердің архитектурасын зерттеу.",
                nameEng: "study the architecture of existing IoT solutions and hardware and software systems in the automation of the industrial Internet of things."
            },
        ],
        formLearnResult: [
            {
                nameRu: "Уметь создавать программное обеспечение (часть мэйнфрейма) для управления IoT-устройством.",
                nameKz: "IoT құрылғысын басқаруға арналған бағдарламалық жасақтаманы (негізгі фреймнің бөлігі) жасай білу.",
                nameEng: "Be able to create software (part of the mainframe) to manage an IoT device."
            },
            {
                nameRu: "Уметь управлять функционалом встроенных систем, выбирать средства и технологии их разработки, оценивать эффективность их использования в различных прикладных областях в рамках IoT.",
                nameKz: "Ендірілген жүйелердің функционалдығын басқара білу, оларды әзірлеу құралдары мен технологияларын таңдау, оларды iota шеңберінде әртүрлі қолданбалы салаларда пайдалану тиімділігін бағалау.",
                nameEng: "Be able to manage the functionality of embedded systems, select tools and technologies for their development, and evaluate the effectiveness of their use in various application areas within the IoT."
            },
            {
                nameRu: "Уметь работать с наборами для быстрого прототипирования, микрокомпьютеров и другие высокотехнологичных IoT-устройств.",
                nameKz: "Жылдам прототиптеу жиынтықтарымен, микрокомпьютерлермен және басқа да жоғары технологиялық IoT құрылғыларымен жұмыс істей білу.",
                nameEng: "Be able to work with rapid prototyping kits, microcomputers and other high-tech IoT devices."
            },
            {
                nameRu: "Уметь использовать технологий беспроводных сетей в работе с подключенными IoT-устройствами.",
                nameKz: "Қосылған IoT құрылғыларымен жұмыс жасауда сымсыз желі технологияларын қолдана білу.",
                nameEng: "Be able to use wireless network technologies when working with connected IoT devices."
            },
            {
                nameRu: "Уметь разрабатывать комплексы программно-аппаратных решений интернета вещей.",
                nameKz: "Заттар интернетінің бағдарламалық және аппараттық шешімдерінің кешендерін жасай білу.",
                nameEng: "Be able to develop complexes of software and hardware solutions for the Internet of Things."
            },
            {
                nameRu: "Уметь создавать новое программное обеспечение — операционную систему для «интернета вещей».",
                nameKz: "Жаңа бағдарламалық жасақтаманы — «Заттар интернеті»үшін операциялық жүйені құра білу.",
                nameEng: "Be able to create new software – an operating system for the Internet of Things."
            },
            {
                nameRu: "Уметь управлять и проектировать новые технологии в рамках четвертой промышленной революции в рамках создания цифрового производства на базе IoT-устройств.",
                nameKz: "IoT құрылғылары негізінде Цифрлық өндірісті құру шеңберінде Төртінші өнеркәсіптік революция шеңберінде жаңа технологияларды басқара және жобалай білу.",
                nameEng: "Be able to manage and design new technologies within the framework of the fourth industrial revolution as part of the creation of digital production based on IoT devices."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Операционные системы для встроенных систем",
                    nameKz: "Кірістірілген жүйелер үшін операциялық жүйелер",
                    nameEng: "Operating systems for embedded systems"
                },
                desc: {
                    nameRu: "Курс направлен на приобретение студентами навыков использования современных операционных систем реального времени, получение представления об архитектуре операционных систем реального времени и программных моделях современных микроконтроллеров, овладение практическими навыками создания встраиваемого программного обеспечения с использованием UNIX подобных многозадачных операционных систем реального времени",
                    nameKz: "Курс студенттерге көптеген операциялық жүйелерді пайдалану дағдыларын үйрету, операциялық жүйелердің архитектурасы және заманауи микроконтроллерлердің бағдарламалық модельдері туралы түсінік алу, UNIX төркелген көптеген операциялық жүйелерді пайдалануға бағытталған курстың мақсаты.",
                    nameEng: "The course is aimed at students acquiring skills in using modern real-time operating systems, gaining an understanding of the architecture of real-time operating systems and software models of modern microcontrollers, mastering practical skills in creating embedded software using UNIX-like multitasking real-time operating systems"
                },
                creditNum: 3,
                acaHrNum: 90,
                codes: "ПК3, ПК4, ПК5"
            },
            {
                name: {
                    nameRu: "Проектирование встроенных систем",
                    nameKz: "Кірістірілген жүйелерді дайындау",
                    nameEng: "Embedded Systems Design"
                },
                desc: {
                    nameRu: "Курс посвящен проектированию и особенности функционирования встроенных систем. Курс направлен на формирование у студентов представление о встроенных системах, специфике их проектирования и эксплуатации. В результате обучения происходит формирование базовой системы знаний и навыков, позволяющей понимать принципы функционирования встроенных систем, выбирать средства и технологии их разработки, оценивать эффективность их использования в различных прикладных областях, включая IoT",
                    nameKz: "Курс встроенді жүйелерді дайындау және олардың функционированиясындағы арнайылықтарына арналған. Оқыту студенттерге встроенді жүйелер туралы кеңес беру, оларды дайындау және қолдану ерекшеліктері туралы түсініктерін қалыптастыруға бағытталған. Оқыту аяқталған кезде, оқушылар встроенді жүйелердің функционирования принциптерін, оларды дайындау құралдары мен технологияларын таңдау, оларды өндіру және пайдалану салаларында кәсіби құзыреттерді қалыптастырады, оларды Интернеттің несиесінен бастап әртүрлі қолданбалы салаларда қолдану мүмкіндігін бағалауға мүмкіндік беретін базалық білім мен дағдыларды қалыптастырады.",
                    nameEng: "The course is devoted to the design and features of the functioning of embedded systems. The course is aimed at developing students’ understanding of embedded systems, the specifics of their design and operation. As a result of training, a basic system of knowledge and skills is formed that allows one to understand the principles of functioning of embedded systems, select tools and technologies for their development, and evaluate the effectiveness of their use in various application areas, including IoT"
                },
                creditNum: 4,
                acaHrNum: 90,
                codes: "ПК3, ПК4, ПК5"
            },
            {
                name: {
                    nameRu: "Сетевые протоколы для IoT",
                    nameKz: "IoT үшін желілік протоколдар",
                    nameEng: "Network protocols for IoT\t"
                },
                desc: {
                    nameRu: "Данный курс нацелен на изучения технологий беспроводных сетей включая сети с низким энергопотреблением разного радиуса действия, понимания принципа работы и сценария использования, будут также рассматриваться специфичные протоколы такие как MQTT, AMQP, CoAP, DDS, XMPP, JMS.",
                    nameKz: "Мысалы MQTT, AMQP, CoAP, DDS, XMPP, JMS сияқты арнайы хаттамаларды қарастыру және беспроводдық желілік желілерді зерттеу мәqsatүзді хаттамаларды зерттеп, әдістері мен қолдану сценарийлерін түсініктеуге бағытталған курс.",
                    nameEng: "This course is aimed at studying wireless network technologies including low-power networks of different ranges, understanding the operating principle and use case, specific protocols such as MQTT, AMQP, CoAP, DDS, XMPP, JMS will also be considered."
                },
                creditNum: 3,
                acaHrNum: 120,
                codes: "ПК1, ПК2, ПК3, ПК5, ПК6"
            },
            {
                name: {
                    nameRu: "Разработка IoT систем",
                    nameKz: "IoT жүйелерін жасау",
                    nameEng: "Development of IoT systems"
                },
                desc: {
                    nameRu: "Курс является практико-ориентированным и формирует у обучающихся навыки разработки комплексных программно-аппаратных решений интернета вещей. Первый раздел курса ознакомит обучающихся с SDK платформой, набором инструментов и практиками программирования для устройств промышленного интернета вещей. Во втором разделе обучающиеся разработают и презентуют авторское решение системы интернета вещей.",
                    nameKz: "Курс практикалық-ориентирлікті және оқушыларға интернеттің несиесінің жобалау дағдыларын қалыптастырады. Курс бірінші бөлімі оқушыларды SDK платформасымен, құралдар жиынтығымен және индустриялық Интернеттің заттарына арналған өнеркәсіптік интернеттің бағдарламаларымен таныстырады. Екінші бөлімде оқушылар Интернеттің заттары жүйесінің авторлық шешімдерін жасайды және тағылымдайды.",
                    nameEng: "The course is practice-oriented and develops students’ skills in developing complex software and hardware solutions for the Internet of Things. The first section of the course will introduce students to the SDK platform, a set of tools and programming practices for industrial Internet of things devices. In the second section, students will develop and present an original solution for an Internet of Things system."
                },
                creditNum: 4,
                acaHrNum: 120,
                codes: "ПК1, ПК2, ПК3, ПК5, ПК6"
            },
        ]
    },
    {
        id: 8,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "ML Specialist (встроенная)",
            nameKz: "ML Specialist (кірістірілген)",
            nameEng: "ML Specialist (integrated)"
        },
        partnerOrg: {
            nameRu: "«Корпоративный университет» — филиал АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ Корпоративтік университеті",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0011",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Программа направлена на подготовку специалистов в области машинного обучения и анализа больших данных, на получение компетенций, необходимых для выполнения нового вида профессиональной деятельности — умения применять языки программирования SQL и Python для сбора, визуализации, анализа больших данных (Big data) и построение моделей машинного обучения, умения применять конкретные аналитические и продуктовые подходы.",
            nameKz: "Бағдарлама Машиналық оқыту және үлкен деректерді талдау саласындағы мамандарды даярлауға, кәсіби қызметтің жаңа түрін — үлкен деректерді жинау, визуализациялау, талдау (Big data) үшін SQL және Python бағдарламалау тілдерін қолдана білуге және машиналық оқыту модельдерін құруға, нақты аналитикалық және өнімдік тәсілдерді қолдана білуге бағытталған.",
            nameEng: "The program is aimed at training specialists in the field of machine learning and big data analysis, obtaining the competencies necessary to perform a new type of professional activity – the ability to use the SQL and Python programming languages for collecting, visualizing, analyzing big data (Big data) and building machine learning models , ability to apply specific analytical and product approaches."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков у обучающихся анализа задач машинного обучения и взвешенного выбора того или иного решения по работам с большими данными.",
            nameKz: "Білім алушыларда Машиналық оқыту міндеттерін талдау және үлкен деректермен жұмыс істеу бойынша қандай да бір шешімді салмақты таңдау дағдыларын қалыптастыру.",
            nameEng: "Developing skills in students to analyze machine learning problems and make a balanced choice of one or another solution for working with big data."
        },
        tasksEPMQ: [
            {
                nameRu: "воспитание информационной, технической и исследовательской культуры;",
                nameKz: "ақпараттық, техникалық және зерттеу мәдениетін тәрбиелеу;",
                nameEng: "education of information, technical and research culture;"
            },
            {
                nameRu: "развитие интереса к научно-техническому творчеству, технике, высоким технологиям;",
                nameKz: "ғылыми-техникалық шығармашылыққа, техникаға, жоғары технологияларға қызығушылықты дамыту;",
                nameEng: "development of interest in scientific and technical creativity, technology, high technologies;"
            },
            {
                nameRu: "развитие алгоритмического и логического мышления;",
                nameKz: "алгоритмдік және логикалық ойлауды дамыту;",
                nameEng: "development of algorithmic and logical thinking;"
            },
            {
                nameRu: "сформировать теоретические знания по основам машинного обучения для построения формальных математических моделей и интерпретации результатов моделирования;",
                nameKz: "формальды математикалық модельдерді құру және модельдеу нәтижелерін түсіндіру үшін машиналық оқыту негіздері бойынша теориялық білім қалыптастыру;",
                nameEng: "to form theoretical knowledge on the basics of machine learning for constructing formal mathematical models and interpreting modeling results;"
            },
            {
                nameRu: "выработать умения по практическому применению методов машинного обучения при решении прикладных задач в различных областях;",
                nameKz: "әртүрлі салалардағы қолданбалы есептерді шешуде Машиналық оқыту әдістерін практикалық қолдану бойынша дағдыларды дамыту;",
                nameEng: "develop skills in the practical application of machine learning methods in solving applied problems in various fields;"
            },
            {
                nameRu: "выработать умения и навыки использования библиотек языка Python для разработки систем машинного обучения.",
                nameKz: "машиналық оқыту жүйелерін әзірлеу үшін Python тіл кітапханаларын пайдалану дағдылары мен дағдыларын дамыту.",
                nameEng: "develop skills in using Python libraries to develop machine learning systems."
            }
        ],
        formLearnResult: [
            {
                nameRu: "правильно выбирать данные и переводить их в понятный машине формат;",
                nameKz: "деректерді дұрыс таңдап оны машинада түсінікті форматқа аударыңыз;",
                nameEng: "select the data correctly and translate it into a machine-readable format;"
            },
            {
                nameRu: "проектировать и обучать нейронные сети и другие модели машинного обучения;",
                nameKz: "нейрондық желілерді және машиналық оқытудың басқа модельдерін жобалау және оқыту;",
                nameEng: "design and train neural networks and other machine learning models;"
            },
            {
                nameRu: "оценивать, насколько хорошо нейронные сети справляются со своими задачами;",
                nameKz: "нейрондық желілердің өз міндеттерін қаншалықты жақсы орындайтынын бағалау;",
                nameEng: "evaluate how well neural networks cope with their tasks;"
            },
            {
                nameRu: "пользоваться фреймворком PyTorch, библиотекой Tensorflow и Keras API;",
                nameKz: "PyTorch шеңберін, TensorFlow кітапханасын және keras API пайдаланыңыз;",
                nameEng: "use the PyTorch framework, Tensorflow library and Keras API;"
            },
            {
                nameRu: "использовать имеющиеся знания для решения практических задач глубокого обучения;",
                nameKz: "терең оқытудың практикалық мәселелерін шешу үшін қолда бар білімді пайдалану;",
                nameEng: "use existing knowledge to solve practical deep learning problems;"
            },
            {
                nameRu: "ориентироваться в понятиях мира Больших Данных, Машинного обучения и Интернета Вещей;",
                nameKz: "үлкен деректер әлемі, Машиналық оқыту және Заттар интернеті ұғымдарын басшылыққа алыңыз;",
                nameEng: "navigate the concepts of the world of Big Data, Machine Learning and the Internet of Things;"
            },
            {
                nameRu: "знать отличия разных версий дистрибутивов Hadoop, Spark, NoSQL или Kafka;",
                nameKz: "Hadoop, Spark, NoSQL немесе Kafka дистрибутивтерінің әртүрлі нұсқаларының айырмашылықтарын біліңіз;",
                nameEng: "know the differences between different versions of Hadoop, Spark, NoSQL or Kafka distributions;"
            },
            {
                nameRu: "определять нюансы облачных решений;",
                nameKz: "бұлтты шешімдердің нюанстарын анықтаңыз;",
                nameEng: "identify the nuances of cloud solutions;"
            },
            {
                nameRu: "знать, что такое стандарт GDPR;",
                nameKz: "GMP стандартының не екенін біліңіз;",
                nameEng: "know what the GDPR standard is;"
            },
            {
                nameRu: "определять особенности Индустриального интернета Вещей.",
                nameKz: "заттардың индустриялық интернетінің ерекшеліктерін анықтаңыз.",
                nameEng: "determine the features of the Industrial Internet of Things."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Machine Learning",
                    nameKz: "Машиналық оқыту",
                    nameEng: "Machine Learning"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у обучающихся теоретических знаний и практических навыков по основам машинного обучения, овладение слушателями инструментарием, моделями и методами машинного обучения.",
                    nameKz: "Курста студенттерге машиналық оқыту негіздері бойынша теориялық білім мен практикалық дағдыларды қалыптастыру, олардың машиналық оқыту құралдарын, үлгілері мен әдістерін меңгеру мақсатында жетістіктерін бағалауға бағытталған.",
                    nameEng: "The goal of the discipline is to develop students’ theoretical knowledge and practical skills in the basics of machine learning, and students to master the tools, models and methods of machine learning."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3, ПК5, ПК6"
            },
            {
                name: {
                    nameRu: "Deep learning",
                    nameKz: "Терең оқыту",
                    nameEng: "Deep learning"
                },
                desc: {
                    nameRu: "Целью освоения дисциплины является освоение алгоритмов и методов глубокого обучения; формирование умений и навыков в решении практических задач с использованием методов глубокого обучения.",
                    nameKz: "Курста терең оқыту алгоритмдері мен әдістерін меңгеру; терең оқыту әдістерін пайдалана отырып, практикалық есептерді шешуде дағдылар мен дағдыларды қалыптастыру мақсатында бағалауға бағытталған.",
                    nameEng: "The goal of mastering the discipline is to master the algorithms and methods of deep learning; developing skills and abilities in solving practical problems using deep learning methods."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3, ПК5"
            },
            {
                name: {
                    nameRu: "Big data",
                    nameKz: "Үлкен деректер",
                    nameEng: "Big data"
                },
                desc: {
                    nameRu: "Формирование у обучающихся профессиональной компетенции в области разработки и использования систем обработки и анализа больших массивов данных.",
                    nameKz: "Курста деректердің үлкен массивтерін өңдеу және талдау жүйелерін әзірлеу және қолдану саласында кәсіби құзыреттілікті қалыптастыру мақсатында бағалауға бағытталған.",
                    nameEng: "Formation of professional competence in students in the field of development and use of systems for processing and analyzing large data sets."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3, ПК4"
            }
        ]
    },
    {
        id: 9,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "Statistics Essentials (встроенная)",
            nameKz: "Statistics Essentials (кірістірілген)",
            nameEng: "Statistics Essentials (integrated)"
        },
        partnerOrg: {
            nameRu: "«Корпоративный университет» — филиал АО «Казахтелеком»",
            nameKz: "«Қазақтелеком» АҚ Корпоративтік университеті",
            nameEng: "Kazakhtelecom JSC Corporate University"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0010",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Программа направлена на подготовку специалистов по моделированию производственных процессов на основе математической статистики и анализа данных, имеющих прочные фундаментальные знания математики и в прикладных методах, основанных на вычислительных технологиях.",
            nameKz: "Бағдарлама Математика және есептеу технологияларына негізделген қолданбалы әдістер туралы берік іргелі білімі бар математикалық статистика мен деректерді талдау негізінде өндірістік процестерді модельдеу бойынша мамандарды даярлауға бағытталған.",
            nameEng: "The program is aimed at training specialists in the modeling of production processes based on mathematical statistics and data analysis, with a strong fundamental knowledge of mathematics and in applied methods based on computational technologies."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков у обучающихся правильного применения методов математической статистики к различным прикладным задачам, а также предоставление обучающимся полноценный комплекс знаний по статистике, необходимых для успешного применения мощного инструмента статистического анализа.",
            nameKz: "Білім алушылардың әртүрлі қолданбалы есептерге математикалық статистика әдістерін дұрыс қолдану дағдыларын қалыптастыру, сондай-ақ білім алушыларға статистикалық талдаудың қуатты құралын табысты қолдану үшін қажетті статистика бойынша білімнің толыққанды кешенін ұсыну.",
            nameEng: "Formation of students’ skills in the correct application of methods of mathematical statistics to various applied problems, as well as providing students with a full range of knowledge in statistics necessary for the successful use of a powerful tool of statistical analysis."
        },
        tasksEPMQ: [
            {
                nameRu: "сформировать у обучающихся целостное представление о принципах математической статистики и анализа;",
                nameKz: "білім алушыларда математикалық статистика және талдау принциптері туралы тұтас түсінік қалыптастыру;",
                nameEng: "to form in students a holistic understanding of the principles of mathematical statistics and analysis;"
            },
            {
                nameRu: "привить навыки сознательного и рационального использования современных инструментальных программных средств в профессиональной деятельности для решения конкретных задач.",
                nameKz: "нақты міндеттерді шешу үшін кәсіби қызметте заманауи аспаптық бағдарламалық құралдарды саналы және ұтымды пайдалану дағдыларын қалыптастыру.",
                nameEng: "to instill the skills of conscious and rational use of modern software tools in professional activities to solve specific problems."
            }
        ],
        formLearnResult: [
            {
                nameRu: "знать методы анализа, систематизации, представления и обобщения данных путем применения комплекса методов при решении конкретных задач;",
                nameKz: "нақты мәселелерді шешуде әдістер кешенін қолдану арқылы деректерді талдау, жүйелеу, ұсыну және жалпылау әдістерін білу;",
                nameEng: "Understand methods of data analysis, systematization, representation, and generalization through the application of a complex of methods to solve specific tasks."
            },
            {
                nameRu: "использовать статистические методы для решения конкретных задач;",
                nameKz: "нақты есептерді шешу үшін статистикалық әдістерді қолданыңыз;",
                nameEng: "Utilize statistical methods to solve specific tasks."
            },
            {
                nameRu: "уметь грамотно и корректно подготавливать данные для статистического анализа;",
                nameKz: "статистикалық талдау үшін деректерді сауатты және дұрыс дайындай білу;",
                nameEng: "Demonstrate proficiency in preparing data accurately and appropriately for statistical analysis."
            },
            {
                nameRu: "разрабатывать математические модели и численные алгоритмы и выбирать вычислительные методы для проведения вычислительных экспериментов и прогнозирования течения детерминированных и вероятностных процессов;",
                nameKz: "математикалық модельдер мен сандық алгоритмдерді әзірлеу және есептеу эксперименттерін жүргізу және детерминирленген және ықтималдық процестерінің барысын болжау үшін есептеу әдістерін таңдау;",
                nameEng: "Develop mathematical models and numerical algorithms and select computational methods for conducting computational experiments and forecasting deterministic and probabilistic processes."
            },
            {
                nameRu: "собирать, обрабатывать и анализировать данные, с использованием методов математической статистики, науки о данных и машинного обучения для составления прогнозов и подготовки управленческих и оперативных рекомендации.",
                nameKz: "болжам жасау және басқару және операциялық ұсыныстарды дайындау үшін математикалық статистика, деректер ғылымы және машиналық оқыту әдістерін қолдана отырып, деректерді жинау, өңдеу және талдау.",
                nameEng: "Collect, process, and analyze data using methods of mathematical statistics, data science, and machine learning to make forecasts and prepare managerial and operational recommendations."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Теория вероятностей и математическая статистика",
                    nameKz: "Ықтималдықтар теориясы және математикалық статистика",
                    nameEng: "Probability Theory and Mathematical Statistics"
                },
                desc: {
                    nameRu: "Дисциплина направлена на обучение изучения закономерностей случайных явлений и их свойств, и использовать их для анализа данных. В результате изучения данной дисциплины обучающиеся будут знать основные понятия теории вероятностей и математической статистики и их свойства, а также уметь использовать вероятностные модели при решении задач, работать со случайными величинами, выполнять расчет выборочных характеристик, оценивать надежность статистических данных.",
                    nameKz: "пән кездейсоқ құбылыстардың заңдылықтарын және олардың қасиеттерін зерттеуге және оларды деректерді талдау үшін пайдалануға үйретуге бағытталған. Осы пәнді оқу нәтижесінде студенттер Ықтималдықтар теориясы мен математикалық статистиканың негізгі ұғымдарын және олардың қасиеттерін біледі, сонымен қатар есептерді шешуде ықтималдық модельдерін қолдана алады, кездейсоқ шамалармен жұмыс істейді, таңдамалы сипаттамаларды есептейді, статистикалық мәліметтердің сенімділігін бағалайды.",
                    nameEng: "This discipline is aimed at teaching the study of the regularities of random phenomena and their properties, and using them for data analysis. As a result of studying this discipline, students will know the basic concepts of probability theory and mathematical statistics and their properties, as well as be able to use probabilistic models to solve problems, work with random variables, calculate sample characteristics, and assess the reliability of statistical data."
                },
                creditNum: 5,
                acaHrNum: 120,
                codes: "ПК1, ПК2, ПК5"
            },
            {
                name: {
                    nameRu: "Математический анализ",
                    nameKz: "Математикалық талдау",
                    nameEng: "Mathematical Analysis"
                },
                desc: {
                    nameRu: "Дисциплина направлена на изучение методов анализа данных для количественной оценки социально-экономической ситуации на микро, макро и глобальном уровнях; проведения статистического анализа.",
                    nameKz: "пән микро, макро және жаһандық деңгейлердегі әлеуметтік-экономикалық жағдайды сандық бағалау үшін деректерді талдау әдістерін зерттеуге бағытталған; статистикалық талдау жүргізу.",
                    nameEng: "This discipline is aimed at studying methods of data analysis for quantitative assessment of the socio-economic situation at micro, macro, and global levels; conducting statistical analysis."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК3, ПК4, ПК5"
            },
            {
                name: {
                    nameRu: "Введение в аналитику больших данных",
                    nameKz: "Үлкен деректер аналитикасына кіріспе",
                    nameEng: "Introduction to Big Data Analytics"
                },
                desc: {
                    nameRu: "Курс предназначен для изучения основ рабоы с большими данными, огромными массивами структурированной информации. Обучающиеся научатся работать с технологиями MapReduce, Hadoop, Spark для реализации аналитики и машинного обучения на больших данных.",
                    nameKz: "Курс үлкен деректермен, үлкен құрылымдалған ақпарат массивтерімен жұмыс істеу негіздерін зерттеуге арналған. Білім алушылар MapReduce, Hadoop, Spark технологияларымен үлкен деректерде аналитика мен машиналық оқытуды жүзеге асыру үшін жұмыс істеуді үйренеді.",
                    nameEng: "The course is designed to study the basics of working with big data, huge arrays of structured information. Students will learn to work with MapReduce, Hadoop, Spark technologies for implementing analytics and machine learning on big data."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3"
            }
        ]
    },
    {
        id: 10,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "Mobile App Developer",
            nameKz: "Mobile App Developer",
            nameEng: "Mobile App Developer"
        },
        partnerOrg: {
            nameRu: "Samsung Electronics Central Eurasia",
            nameKz: "Samsung Electronics Central Eurasia",
            nameEng: "Samsung Electronics Central Eurasia"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2023/0007",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение ключевых инструментов, методов и технологий, которые позволят разрабатывать мобильные приложения.",
            nameKz: "Мобильді қосымшаларды жасауға мүмкіндік беретін негізгі құралдарды, әдістер мен технологияларды игеру.",
            nameEng: "mastering key tools, methods and technologies that will allow you to develop mobile applications."
        },
        goalEPMQ: {
            nameRu: "Обеспечение практико-ориентированную подготовку специалистов в области разработки мобильных приложений",
            nameKz: "Мобильді қосымшаларды әзірлеу саласында мамандарды тәжірибеге бағдарланған даярлауды қамтамасыз ету",
            nameEng: "Providing practice-oriented training for specialists in the field of mobile application development"
        },
        tasksEPMQ: [
            {
                nameRu: "развить навык командной работы;",
                nameKz: "топтық жұмыс дағдыларын дамыту;",
                nameEng: "develop teamwork skills;"
            },
            {
                nameRu: "развить понимание и сформировать опыт в изучении ключевых проблем реализации приложений;",
                nameKz: "қосымшаларды іске асырудың негізгі мәселелерін зерделеуде түсінік қалыптастыру және тәжірибе қалыптастыру;",
                nameEng: "develop understanding and develop experience in studying the key problems of application implementation;"
            },
            {
                nameRu: "развить навыки разработки приложений.",
                nameKz: "қосымшаларды әзірлеу дағдыларын дамыту.",
                nameEng: "develop application development skills."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Применять отечественные и зарубежные стандарты по разработке программного обеспечения в организациях;",
                nameKz: "Ұйымдарда бағдарламалық қамтамасыз етуді әзірлеу бойынша отандық және шетелдік стандарттарды қолдану;",
                nameEng: "Apply domestic and foreign standards for software development in organizations;"
            },
            {
                nameRu: "Применять технические средства и программные сервисы для обеспечения непрерывности процесса разработки мобильных приложений;",
                nameKz: "Мобильді қосымшаларды әзірлеу процесінің үздіксіздігін қамтамасыз ету үшін техникалық құралдар мен бағдарламалық сервистерді қолдану;",
                nameEng: "Use technical tools and software services to ensure continuity of the mobile application development process;"
            },
            {
                nameRu: "Объяснять и понимать нормативную базу, включая документы, процедуры стандартизации и сертификации в области разработки информационно-коммуникационных технологий;",
                nameKz: "Ақпараттық-коммуникациялық технологияларды әзірлеу саласындағы құжаттарды, стандарттау және сертификаттау рәсімдерін қоса алғанда, нормативтік базаны түсіндіру және түсіну;",
                nameEng: "Explain and understand the regulatory framework, including documents, standardization and certification procedures in the field of information and communication technologies development;"
            },
            {
                nameRu: "Разрабатывать мобильные приложения.",
                nameKz: "Мобильді қосымшаларды әзірлеу.",
                nameEng: "Develop mobile applications."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Объектно-ориентированное программирование",
                    nameKz: "Объектілік-бағытталған бағдарламалау",
                    nameEng: "Object-oriented programming"
                },
                desc: {
                    nameRu: "Курс предназначен для изучения объектно-ориентированного программирования. Включает в себя изучение принципов объектно-ориентированного программирования (классы, объекты, шаблоны и т.д.), получат понятийный аппарат объектно-ориентированного программирования (полиморфизм, инкапсуляция, наследование, конструктор и т.д.), сформируют понимание принципа повторного использования кода в программировании.",
                    nameKz: "Курс объектіге бағытталған бағдарламалауды үйренуге арналған. Объектіге бағытталған бағдарламалау принциптерін (сыныптар, объектілер, шаблондар және т.б.) зерттеуді қамтиды, объектіге бағытталған бағдарламалаудың тұжырымдамалық аппаратын алады (полиморфизм, инкапсуляция, мұрагерлік, конструктор және т. б.), бағдарламалауда кодты қайта пайдалану принципін түсінуді қалыптастырады.",
                    nameEng: "The course is designed to study object-oriented programming. Includes studying the principles of object-oriented programming (classes, objects, templates, etc.), gaining the conceptual apparatus of object-oriented programming (polymorphism, encapsulation, inheritance, constructor, etc.), developing an understanding of the principle of code reuse in programming."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК3"
            },
            {
                name: {
                    nameRu: "Нативная Мобильная Разработка",
                    nameKz: "Нативті Мобильді Әзірлеу",
                    nameEng: "Native Mobile Development"
                },
                desc: {
                    nameRu: "Этот курс предназначен для изучения основ мобильной разработки. Мобильные приложения, полученные в результате прохождения курса, могут быть загружены в университетские репозитории, а также отображены в Play Store.",
                    nameKz: "Бұл курс мобильді дамудың негіздерін үйренуге арналған. Курстан алынған мобильді қосымшалар университет репозиторийлеріне жүктелуі мүмкін, сонымен қатар Play Store дүкенінде көрсетілуі мүмкін.",
                    nameEng: "This course is designed to teach you the fundamentals of mobile development. Mobile applications obtained as a result of completing the course can be uploaded to university repositories and also displayed in the Play Store."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3"
            },
            {
                name: {
                    nameRu: "Кроссплатформенная мобильная разработка",
                    nameKz: "Кроссплатформалы мобильді әзірлеу",
                    nameEng: "Cross-platform mobile development"
                },
                desc: {
                    nameRu: "Этот курс предназначен для продвинутых мобильных операционных систем. Мобильные приложения, полученные в результате курсовой работы, можно загрузить в университетском репозитории, также загруженном в Play Store.",
                    nameKz: "Бұл курс жетілдірілген мобильді операциялық жүйелерге арналған. Курстық жұмыстан алынған Мобильді қосымшаларды Play Store дүкенінен жүктелген университет репозиторийінен жүктеуге болады.",
                    nameEng: "This course is designed for advanced mobile operating systems. Mobile applications resulting from coursework can be downloaded from the university repository, also uploaded to the Play Store."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3"
            }
        ]
    },
    {
        id: 11,
        educationField: {
            nameRu: "Социальные науки, журналистика и информация",
            nameKz: "Әлеуметтік ғылымдар, журналистика және ақпарат",
            nameEng: "Social sciences, journalism and information",
            code: ""
        },
        trainingDirection: {
            nameRu: "Журналистика и информация",
            nameKz: "Журналистика және ақпарат",
            nameEng: "Journalism and information",
            code: ""
        },
        groupEP: {
            nameRu: "Журналистика и репортерское дело",
            nameKz: "Журналистика және репортер",
            nameEng: "Journalism and reporting",
            code: ""
        },
        microQEP: {
            nameRu: "Режиссер видеомонтажа",
            nameKz: "Видеомонтаж режиссері",
            nameEng: "Video editing director"
        },
        partnerOrg: {
            nameRu: "ТОО «OSTOV QAZAQSTAN»",
            nameKz: "«OSTOV QAZAQSTAN» ЖШС",
            nameEng: "OSTOV QAZAQSTAN LLP"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0009",
        regDate: "04.05.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение ключевых инструментов, методов и технологий, которые позволят работать с видео разных жанров и форматов — от рекламных роликов до репортажей и документальных фильмов, а также изучить основы стилизации, цветокоррекции, визуальных эффектов и саунд-дизайна. Выпускники данной ОП будут востребованы на YouTube-проектах, телевидении, в рекламных агентствах и кинокомпаниях.",
            nameKz: "жарнамалық роликтерден бастап репортаждар мен деректі фильмдерге дейін әр түрлі жанрдағы және форматтағы бейнелермен жұмыс істеуге мүмкіндік беретін негізгі құралдарды, әдістер мен технологияларды игеру, сонымен қатар сәндеу, түстерді түзету, визуалды эффектілер мен дыбыстық дизайн негіздерін үйрену. Бұл ББ түлектері YouTube-жобаларда, теледидарда, жарнама агенттіктерінде және кинокомпанияларда сұранысқа ие болады",
            nameEng: "mastering key tools, methods and technologies that will allow you to work with videos of different genres and formats – from commercials to reports and documentaries, as well as learn the basics of stylization, color correction, visual effects and sound design. Graduates of this EP will be in demand on YouTube projects, television, advertising agencies and film companies."
        },
        goalEPMQ: {
            nameRu: "Развитие навыков креативного монтажа видео- и аудиоконтента различных жанров и форматов.",
            nameKz: "Әр түрлі жанрлар мен форматтағы бейне және аудио мазмұнды креативті монтаждау дағдыларын дамыту.",
            nameEng: "Development of skills in creative editing of video and audio content of various genres and formats."
        },
        tasksEPMQ: [
            {
                nameRu: "систематизировать и обогатить предшествующие знания о видеопродакшне и практический опыт;",
                nameKz: "бейне өндіріс туралы алдыңғы білімді және практикалық тәжірибені жүйелеу және байыту;",
                nameEng: "systematize and enrich previous knowledge about video production and practical experience;"
            },
            {
                nameRu: "обучить планированию этапов видеопроизводства и адаптации контента под разные площадки;",
                nameKz: "бейне өндірісінің кезеңдерін жоспарлауға және мазмұнды әртүрлі сайттарға бейімдеуге үйрету;",
                nameEng: "teach planning stages of video production and adapting content for different platforms;"
            },
            {
                nameRu: "развить навыки профессиональной работы с цветом, звуком и анимацией;",
                nameKz: "түспен, дыбыспен және анимациямен кәсіби жұмыс істеу дағдыларын дамыту;",
                nameEng: "develop skills in professional work with color, sound and animation;"
            },
            {
                nameRu: "развить навыки использования специального оборудования, программного обеспечения и работы на площадке;",
                nameKz: "арнайы жабдықты, бағдарламалық қамтамасыз етуді пайдалану және алаңда жұмыс істеу дағдыларын дамыту;",
                nameEng: "develop skills in using special equipment, software and working on site;"
            },
            {
                nameRu: "сформировать умение написания и конструирования визуального сторителлинга;",
                nameKz: "көрнекі әңгімелерді жазу және құрастыру қабілетін қалыптастыру;",
                nameEng: "develop the ability to write and construct visual storytelling;"
            },
            {
                nameRu: "развить навыки межличностного взаимодействия и командной работы.",
                nameKz: "тұлғааралық қарым-қатынас және топтық жұмыс дағдыларын дамыту.",
                nameEng: "develop skills of interpersonal interaction and teamwork."
            }
        ],
        formLearnResult: [
            {
                nameRu: "применять теоретические знания о видеопродакшн на практике;",
                nameKz: "бейне өндірісі туралы теориялық білімді практикада қолдану;",
                nameEng: "Apply theoretical knowledge of videoproduction in practice."
            },
            {
                nameRu: "уметь выстраивать визуальный сторителлинг в рамках законов драмматургии;",
                nameKz: "драматургия заңдары аясында көрнекі әңгіме құра білу;",
                nameEng: "Be able to construct visual storytelling within the framework of dramaturgy laws."
            },
            {
                nameRu: "уметь формировать и эффективно управлять кадром, использовать инстурменты настройки оборудования, света и звука на площадке;",
                nameKz: "кадрды қалыптастыра және тиімді басқара білу, сайтта жабдықты, жарық пен дыбысты баптау құралдарын пайдалану;",
                nameEng: "Be proficient in forming and effectively managing frames, utilizing tools for adjusting equipment, lighting, and sound on set."
            },
            {
                nameRu: "владеть различными программами композитинга и анимационных эффектов;",
                nameKz: "әр түрлі композиторлық және анимациялық эффект бағдарламаларын меңгеру;",
                nameEng: "Master various compositing programs and animation effects."
            },
            {
                nameRu: "владеть техническими программами аудиоинжиниринга;",
                nameKz: "аудиоинжинирингтің техникалық бағдарламаларын меңгеру;",
                nameEng: "Have proficiency in technical audio engineering programs."
            },
            {
                nameRu: "владеть навыками планирования этапов видеопроизводства и работы с техническим заданием;",
                nameKz: "бейне өндіру кезеңдерін жоспарлау және техникалық тапсырмамен жұмыс істеу дағдыларын меңгеру;",
                nameEng: "Possess skills in planning stages of video production and working with technical specifications."
            },
            {
                nameRu: "уметь организовать работу съемочной группы, адаптировать контент для различных площадок.",
                nameKz: "түсірілім тобының жұмысын ұйымдастыра білу, мазмұнды әртүрлі сайттарға бейімдеу.",
                nameEng: "Be able to organize the work of the filming crew and adapt content for different platforms."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Операторское мастерство и основы монтажа",
                    nameKz: "Операторлық шеберлік және монтаждау негіздері",
                    nameEng: "Camera Mastery and Basics of Editing"
                },
                desc: {
                    nameRu: "Студенты познакомятся с основами операторского мастерства, техникой и технологиями кино— и видеосъемки, основными инструментами видеомонтажа. В рамках практической части обучения студенты будут работать над созданием собственных видеосюжетов, на практике применяя все полученные знания.",
                    nameKz: "Студенттер операторлық шеберлік негіздерімен, кино және бейнетүсірілім техникасы мен технологияларымен, бейнемонтаждың негізгі құралдарымен танысады. Оқытудың практикалық бөлігі ретінде студенттер алған барлық білімдерін іс жүзінде қолдана отырып, өздерінің бейнесюжеттерін жасау үшін жұмыс істейтін болады.",
                    nameEng: "Students will be introduced to the fundamentals of camera mastery, techniques, and technologies of film and video shooting, as well as basic video editing tools. In the practical part of the course, students will work on creating their own video stories, applying all the knowledge they have gained."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3, ПК4"
            },
            {
                name: {
                    nameRu: "Прямые трансляции и стриминг в цифровых медиа",
                    nameKz: "Сандық медиада тікелей эфирлер мен ағындар",
                    nameEng: "Live Broadcasting and Streaming in Digital Media"
                },
                desc: {
                    nameRu: "Курс предполагает приобретение студентами навыков работы в прямом эфире, создания лайв-трансляций. В рамках курса студенты практикуются в применении технологий организации трансляций, принципов и техник работы журналистов во время прямого включения.",
                    nameKz: "Курс студенттердің тікелей эфирде жұмыс істеу, тікелей эфирде хабар тарату дағдыларын игеруін қамтиды. Курс шеңберінде студенттер тікелей қосу кезінде трансляцияларды ұйымдастыру технологияларын, журналистердің жұмыс принциптері мен әдістерін қолданумен айналысады.",
                    nameEng: "The course involves acquiring skills in live broadcasting and creating live streams. Within the course, students practice applying technologies for organizing broadcasts, principles, and techniques of journalists’ work during live broadcasts.\t"
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "К1, ПК2, ПК3, ПК6"
            },
            {
                name: {
                    nameRu: "Основы звукозаписи и редактирования для подкастинга",
                    nameKz: "Подкастингке арналған жазу және өңдеу негіздері",
                    nameEng: "Foundations of Sound Recording and Editing for Podcasting"
                },
                desc: {
                    nameRu: "Курс предназначен для студентов самостоятельно работать над аудио продуктом в соответствии с полным циклом его производства: писать сценарии, режиссировать, снимать и монтировать аудио. Целью курса является формирование знаний и навыков в области использования цифровых медиа и технологий, производство и продюсирование аудио контента.",
                    nameKz: "Курс студенттерге аудио өнімде оны өндірудің толық цикліне сәйкес өз бетінше жұмыс істеуге арналған: сценарий жазу, режиссерлік ету, түсіру және монтаждау. Курстың мақсаты-сандық медиа мен технологияларды қолдану, аудио мазмұнды шығару және шығару бойынша білім мен дағдыларды қалыптастыру.",
                    nameEng: "The course is designed for students to independently work on an audio product throughout the entire production cycle: writing scripts, directing, shooting, and editing audio. The goal of the course is to develop knowledge and skills in the use of digital media and technologies, production, and producing audio content."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК5"
            }
        ]
    },
    {
        id: 12,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B061"
        },
        groupEP: {
            nameRu: "Информационные технологии",
            nameKz: "Ақпараттық технологиялар",
            nameEng: "Information technologies",
            code: 'B057',
        },
        microQEP: {
            nameRu: "Блокчейн разработчик",
            nameKz: "Блокчейн әзірлеуші",
            nameEng: "Blockchain developer"
        },
        partnerOrg: {
            nameRu: "Корпоративный фонд «Международный технопарк IT-стартапов Astana Hub»",
            nameKz: "«Astana Hub IT-стартаптардың халықаралық технопаркі»корпоративтік қоры",
            nameEng: "Corporate Foundation “International Technopark of IT Startups Astana Hub”"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 16,
        regNumber: "MCCE-2022/0012",
        regDate: "05.07.2023",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "освоение ключевых инструментов, фундаментальных концепции, технологий и приложения Blockchain engineering.",
            nameKz: "негізгі құралдарды, іргелі тұжырымдамаларды, технологияларды және blockchain engineering қосымшаларын игеру.",
            nameEng: "mastering key tools, fundamental concepts, technologies and applications of Blockchain engineering."
        },
        goalEPMQ: {
            nameRu: "Обеспечение практико-ориентированную подготовку специалистов по блокчейн-инжинирингу.",
            nameKz: "Блокчейн-Инжиниринг бойынша мамандарды тәжірибеге бағдарланған даярлауды қамтамасыз ету.",
            nameEng: "Providing practice-oriented training for blockchain engineering specialists."
        },
        tasksEPMQ: [
            {
                nameRu: "развить навык проектирования и разработки децентрализованных приложений с использованием технологии блокчейн;",
                nameKz: "блокчейн технологиясын қолдана отырып, орталықтандырылмаған қосымшаларды жобалау және әзірлеу дағдыларын дамыту;",
                nameEng: "develop skills in designing and developing decentralized applications using blockchain technology;"
            },
            {
                nameRu: "развить понимание и сформировать опыт в использовании инструментов для создания децентрализованных приложений;",
                nameKz: "орталықтандырылмаған қосымшаларды құру үшін құралдарды қолдануда түсіністік пен тәжірибе қалыптастыру;",
                nameEng: "develop understanding and gain experience in using tools for creating decentralized applications;"
            },
            {
                nameRu: "развить навыки создания безопасных смарт-контрактов, децентрализованных финансовых сервисов, проектов NFT и GameFi.",
                nameKz: "қауіпсіз ақылды келісімшарттар, орталықтандырылмаған қаржылық қызметтер, NFT және gamefi жобаларын құру дағдыларын дамыту.",
                nameEng: "develop skills in creating secure smart contracts, decentralized financial services, NFT and GameFi projects."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Понимать потенциальные последствия технологии блокчейн для общества и экономики;",
                nameKz: "Блокчейн технологиясының қоғам мен экономика үшін ықтимал салдарын түсіну;",
                nameEng: "Understand the potential implications of blockchain technology for society and the economy."
            },
            {
                nameRu: "Применять технические средства и программные сервисы для обеспечения непрерывности процесса разработки приложений на основе технологии блокчейн;",
                nameKz: "Блокчейн технологиясына негізделген қосымшаларды әзірлеу процесінің үздіксіздігін қамтамасыз ету үшін техникалық құралдар мен бағдарламалық қызметтерді қолдану;",
                nameEng: "Apply technical tools and software services to ensure the continuous development process of blockchain-based applications."
            },
            {
                nameRu: "Объяснять и понимать базовые технологии и концепции блокчейна, включая технологию распределенного реестра, механизмы консенсуса и смарт-контракты;",
                nameKz: "Блокчейннің негізгі технологиялары мен тұжырымдамаларын, соның ішінде таратылған тізілім технологиясын, консенсус механизмдерін және ақылды келісімшарттарды түсіндіру және түсіну;",
                nameEng: "Explain and understand basic blockchain technologies and concepts, including distributed ledger technology, consensus mechanisms, and smart contracts."
            },
            {
                nameRu: "Разрабатывать безопасные смарт-контракты, децентрализованные приложения, децентрализованные финансовые сервисы, проекты NFT и GameFi.",
                nameKz: "Қауіпсіз ақылды келісімшарттарды, орталықтандырылмаған қосымшаларды, орталықтандырылмаған қаржылық қызметтерді, NFT және GameFirst жобаларын әзірлеу.",
                nameEng: "Develop secure smart contracts, decentralized applications, decentralized financial services, NFT projects, and GameFi projects."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Алгоритмы и структуры данных",
                    nameKz: "Алгоритмдер және Мәліметтер құрылымы",
                    nameEng: "Algorithms and Data Structures"
                },
                desc: {
                    nameRu: "Курс рассматривает классические алгоритмы (поиск, сортировка и т.д.) и структуры данных (очередь, стэк, дерево, граф), используемые в программировании.",
                    nameKz: "Курс бағдарламалауда қолданылатын классикалық алгоритмдерді (іздеу, сұрыптау және т.б.) және деректер құрылымдарын (кезек, стек, ағаш, график) қарастырады.",
                    nameEng: "The course covers classic algorithms (searching, sorting, etc.) and data structures (queue, stack, tree, graph) used in programming."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК2"
            },
            {
                name: {
                    nameRu: "Блокчейн технологии 1",
                    nameKz: "Блокчейн технологиялар 1",
                    nameEng: "Blockchain Technologies 1"
                },
                desc: {
                    nameRu: "Курс предназначен для изучения основ блокчейн технологии, архитектуры инженерии блокчейн. Обучающиеся получат понимание криптовалюты и смарт-контрактов, подключение к текстовой сети, исопльзование различных библиотек для разработки Web 3.0.",
                    nameKz: "Курс Blockchain технологиясының негіздерін, blockchain инженерлік архитектурасын зерттеуге арналған. Білім алушылар криптовалюта мен смарт-келісімшарттар туралы түсінік алады, мәтіндік желіге қосылады, Web 3.0 әзірлеу үшін әртүрлі кітапханаларды пайдаланады.",
                    nameEng: "The course is designed to study the fundamentals of blockchain technology, blockchain engineering architecture. Students will gain an understanding of cryptocurrency and smart contracts, connecting to the text network, and using various libraries for Web 3.0 development."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК2, ПК3"
            },
            {
                name: {
                    nameRu: "Блокчейн технологии 2",
                    nameKz: "Блокчейн технологиялар 2",
                    nameEng: "Blockchain Technologies 2"
                },
                desc: {
                    nameRu: "Курс предназначен для тестирования уязвимости смарт-контрактов, разработки децентрализованных приложении. Обучающиеся получат понимание и использование архитектуры блокчейна, также будут разрабатывать децентрализованные приложения.",
                    nameKz: "Курс ақылды келісімшарттардың осалдығын тексеруге, орталықтандырылмаған қосымшаларды әзірлеуге арналған. Білім алушылар блокчейн архитектурасын түсінеді және пайдаланады, сондай-ақ орталықтандырылмаған қосымшаларды әзірлейді.",
                    nameEng: "The course is aimed at testing smart contract vulnerabilities, developing decentralized applications. Students will understand and use blockchain architecture and will also develop decentralized applications."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3, ПК4"
            }
        ]
    },
    {
        id: 13,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        groupEP: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        microQEP: {
            nameRu: "ETHICAL HACKER (автономная)",
            nameKz: "ETHICAL HACKER ",
            nameEng: "ETHICAL HACKER "
        },
        partnerOrg: {
            nameRu: "ТОО «Communications Kazakhstan»",
            nameKz: "«Communications Kazakhstan» ЖШС",
            nameEng: "Communications Kazakhstan LLP"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 10,
        regNumber: "MCCE-2024/0013",
        regDate: "16.08.2024",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Данная программа нацелена на изучение современных подходов по сканированию известных уязвимостей в системе, а также их эксплуатации для дальнейшей проверки. Слушатели ознакомятся с методами и инструментами сканирования уязвимостей, анализировать результаты, и вырабатывать рекомендации по устранению обнаруженных уязвимостей.",
            nameKz: "Бұл бағдарлама жүйедегі белгілі осалдықтарды сканерлеудің заманауи тәсілдерін, сондай-ақ оларды әрі қарай тексеру үшін пайдалануды зерттеуге бағытталған. Студенттер осалдықтарды сканерлеу әдістерімен және құралдарымен танысады, нәтижелерді талдайды және анықталған осалдықтарды жою бойынша ұсыныстар әзірлейді.",
            nameEng: "This program focuses on studying modern approaches to scanning known vulnerabilities within systems and exploiting them for further validation. Participants will learn vulnerability scanning methods, analyze results, and develop recommendations for mitigating identified vulnerabilities."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков по поиску уязвимостей в системах вручную и с использованием сканеров, и проведение мероприятий по ручной эксплуатации для проверки обнаруженных уязвимостей. А также изучение инструментов по тестированию на проникновение",
            nameKz: "Жүйелердегі осалдықтарды қолмен және сканерлерді пайдалану арқылы іздеу дағдыларын дамыту және анықталған осалдықтарды тексеру үшін қолмен жұмыс әрекеттерін жүргізу. Сондай-ақ енуді тексеру құралдарын зерттеу.",
            nameEng: "To develop skills in manually searching for vulnerabilities in systems using scanners and conducting activities to exploit identified vulnerabilities. Also, to study penetration testing tools."
        },
        tasksEPMQ: [
            {
                nameRu: "Подготовка специалистов по направлению «тестирование на проникновение»;",
                nameKz: "«еніп кету сынағы» саласында мамандарды даярлау;",
                nameEng: "Training specialists in penetration testing."
            },
            {
                nameRu: "Формирование теоретических и практических знаний по проведению пентеста;",
                nameKz: "пентест өткізу бойынша теориялық және практикалық білімдерін қалыптастыру;",
                nameEng: "Forming theoretical and practical knowledge in conducting penetration tests."
            },
            {
                nameRu: "Выработка практических навыков по работе с инструментами сканирования и эксплуатации уязвимостей.",
                nameKz: "сканерлеу құралдарымен жұмыс істеу және осалдықтарды пайдалану бойынша практикалық дағдыларды дамыту.",
                nameEng: "Developing practical skills in using vulnerability scanning and exploitation tools."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Проводить полный цикл работ по обнаружению уязвимостей в системах.",
                nameKz: "Жүйелердегі осалдықтарды анықтау бойынша жұмыстың толық циклін орындаңыз.",
                nameEng: "Conducting the full cycle of vulnerability detection in systems."
            },
            {
                nameRu: "Работать с инструментами сканирования уявимостей.",
                nameKz: "Осалдықты сканерлеу құралдарымен жұмыс істеу.",
                nameEng: "Working with vulnerability scanning tools."
            },
            {
                nameRu: "Вырабатывать рекомендации по результатам тестирования на проникновение.",
                nameKz: "Ену сынауының нәтижелері бойынша ұсыныстар жасаңыз.",
                nameEng: "Developing recommendations based on penetration testing results."
            },
            {
                nameRu: "Анализировать архитектуру больших сетевых приложений.",
                nameKz: "Үлкен желілік қолданбалардың архитектурасын талдаңыз.",
                nameEng: "Analyzing the architecture of large-scale network applications."
            },
            {
                nameRu: "Проводить анализ инфраструктуры на предмет поиска уязвимостей.",
                nameKz: "Осалдықтарды іздеу үшін инфрақұрылымды талдауды жүргізіңіз.",
                nameEng: "Conducting infrastructure analysis to identify vulnerabilities."
            },
            {
                nameRu: "Находить и анализировать уязвимости в веб-приложениях.",
                nameKz: "Веб қолданбаларындағы осалдықтарды табыңыз және талдаңыз.",
                nameEng: "Finding and analyzing vulnerabilities in web applications."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Безопасность веб-систем",
                    nameKz: "Веб қауіпсіздігі",
                    nameEng: "Web Systems Security"
                },
                desc: {
                    nameRu: "Данная дисциплина обучает защите веб-приложений и сайтов от киберугроз. Включает анализ уязвимостей, криптографию, и т.д. Студенты изучают современные стандарты безопасности, применяют инструменты для тестирования уязвимостей и разрабатывают стратегии предотвращения инцидентов.",
                    nameKz: "Бұл пән веб-қосымшалар мен веб-сайттарды киберқауіптерден қалай қорғау керектігін үйретеді. Ол осалдықты талдауды, криптографияны және т.б. Студенттер заманауи қауіпсіздік стандарттарын үйренеді, осалдықтарды тексеру үшін құралдарды пайдаланады және оқыс оқиғалардың алдын алу стратегияларын әзірлейді.",
                    nameEng: "This discipline teaches protection of web applications and sites from cyber threats. It includes vulnerability analysis, cryptography, etc. Students learn modern security standards, apply tools for vulnerability testing, and develop incident prevention strategies."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК5, ПК6"
            },
            {
                name: {
                    nameRu: "Пентест веб-приложений",
                    nameKz: "Пентест веб-қосымшалары",
                    nameEng: "Web Application Pentesting"
                },
                desc: {
                    nameRu: "Данная дисциплина фокусируется на методах тестирования безопасности веб-приложений. Студенты изучают техники анализа уязвимостей, таких как SQL-инъекции, кросс-сайтовый скриптинг (XSS), переполнение буфера и другие. Освоение инструментов для сканирования и эксплуатации уязвимостей помогает подготовиться к профессиональной деятельности в области информационной безопасности.",
                    nameKz: "Бұл пән веб-қосымшалардың қауіпсіздігін тексеру әдістеріне бағытталған. Студенттер осалдықты талдау әдістерін үйренеді, мысалы, SQL инъекциясы, сайттар аралық сценарийлер (XSS), буфердің толып кетуі және т.б. Сканерлеу және осалдықтарды пайдалану құралдарын меңгеру сізді ақпараттық қауіпсіздік саласындағы кәсіби мансапқа дайындауға көмектеседі.",
                    nameEng: "This course focuses on security testing methods for web applications. Students study vulnerability analysis techniques such as SQL injection, cross-site scripting (XSS), buffer overflow, and others. Mastery of tools for scanning and exploiting vulnerabilities prepares students for careers in information security."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК4, ПК7"
            },
            {
                name: {
                    nameRu: "Тестирование на проникновение",
                    nameKz: "Ену сынағы",
                    nameEng: "Penetration Testing"
                },
                desc: {
                    nameRu: "Целью дисциплины является выработать навыки работы с инструментами для сканирования уязвимостей, эксплуатации для проверки, и выработка рекомендации по устранению уязвимостей в системах.",
                    nameKz: "Пәннің мақсаты осалдықтарды сканерлеу құралдарымен жұмыс істеу дағдыларын дамыту, оларды тексеру үшін пайдалану және жүйелердегі осалдықтарды жою бойынша ұсыныстар әзірлеу болып табылады.",
                    nameEng: "The aim of this course is to develop skills in using tools for vulnerability scanning, exploitation for verification, and developing recommendations to mitigate vulnerabilities in systems."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3"
            }
        ]
    },
    {
        id: 14,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        groupEP: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        microQEP: {
            nameRu: "CYBER THREAT ANALYST (автономная)",
            nameKz: "CYBER THREAT ANALYST ",
            nameEng: "CYBER THREAT ANALYST "
        },
        partnerOrg: {
            nameRu: "ТОО «Communications Kazakhstan»",
            nameKz: "«Communications Kazakhstan» ЖШС",
            nameEng: "Communications Kazakhstan LLP"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 10,
        regNumber: "MCCE-2024/0014",
        regDate: "16.08.2024",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Данная программа обучает слушателей систематическому анализу сетевой активности для предотвращения компьютерных угроз и инцидентов безопасности. Слушатели изучают методы обнаружения аномалий, анализа данных журналов, а также развивают навыки принятия решений в реальном времени для эффективного реагирования на потенциальные угрозы.",
            nameKz: "Бұл бағдарлама студенттерді компьютерлік қауіптер мен қауіпсіздік инциденттерінің алдын алу үшін желілік белсенділікті жүйелі талдауға үйретеді. Студенттер аномалияларды анықтау әдістерін үйренеді, журнал деректерін талдайды және ықтимал қауіптерге тиімді әрекет ету үшін нақты уақытта шешім қабылдау дағдыларын дамытады.",
            nameEng: "This program equips participants with the skills for systematic analysis of network activity to preempt computer threats and security incidents. Participants study methods for anomaly detection, log data analysis, and develop real-time decision-making abilities to efficiently respond to potential threats. "
        },
        goalEPMQ: {
            nameRu: "Цель данной программы заключается в подготовке специалистов по кибербезопасности, способных проактивно обнаруживать и анализировать потенциальные угрозы в сетевых средах. Слушатели осваивают методы поиска аномалий, анализа данных журналов и принятия оперативных мер для защиты информационных ресурсов организации, способствуя повышению уровня безопасности и минимизации рисков компьютерных атак",
            nameKz: "Бұл бағдарламаның мақсаты желілік орталардағы ықтимал қауіптерді алдын ала анықтауға және талдауға қабілетті киберқауіпсіздік мамандарын дайындау болып табылады. Студенттер аномалияларды іздеу, журнал деректерін талдау және қауіпсіздікті жақсартуға және компьютерлік шабуылдар қаупін азайтуға көмектесетін ұйымның ақпараттық ресурстарын қорғау үшін шұғыл әрекет ету әдістерін үйренеді.",
            nameEng: "The purpose of this program is to prepare cybersecurity specialists capable of proactively detecting and analyzing potential threats in network environments. Participants master methods for anomaly detection, log data analysis, and taking prompt measures to protect an organization's information resources, thereby enhancing security and minimizing the risks of cyber-attacks."
        },
        tasksEPMQ: [
            {
                nameRu: "Задачи данной программы включают изучение техник и инструментов обнаружения аномалий в сетевом трафике, анализа данных журналов и других цифровых следов компьютерных атак. Слушатели также обучаются разрабатывать и реализовывать стратегии предотвращения инцидентов безопасности, адаптированные под уникальные среды и требования организаций.",
                nameKz: "Бұл бағдарламаның мақсаттары желілік трафиктегі ауытқуларды анықтау, журнал деректерін және компьютерлік шабуылдардың басқа сандық іздерін талдау әдістері мен құралдарын зерттеуді қамтиды. Студенттер сонымен қатар ұйымдардың бірегей орталары мен талаптарына бейімделген қауіпсіздік инциденттерінің алдын алу стратегияларын әзірлеуге және енгізуге үйретіледі.",
                nameEng: "The objectives of this program include studying techniques and tools for detecting anomalies in network traffic, analyzing log data and other digital traces of cyber-attacks. Participants also learn to develop and implement incident prevention strategies tailored to the unique environments and requirements of organizations."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Искать потенциальные угрозы в сетевой активности и других цифровых следах.",
                nameKz: "Желідегі әрекетте және басқа сандық іздердегі ықтимал қауіптерді іздеңіз.",
                nameEng: "Search for potential threats in network activity and other digital traces."
            },
            {
                nameRu: "Работать с инструментами для обнаружения и анализа угроз.",
                nameKz: "Қауіптерді анықтау және талдау үшін құралдармен жұмыс істеу.",
                nameEng: "Work with tools for threat detection and analysis."
            },
            {
                nameRu: "Анализировать журналы событий, сетевые трафики и другие данные для выявления аномалий и потенциальных инцидентов.",
                nameKz: "Аномалиялар мен ықтимал оқиғаларды анықтау үшін оқиғалар журналдарын, желілік трафикті және басқа деректерді талдаңыз.",
                nameEng: "Analyze event logs, network traffic, and other data to identify anomalies and potential incidents."
            },
            {
                nameRu: "Использовать современные инструменты и платформы для автоматизации процессов поиска угроз.",
                nameKz: "Қауіпті анықтау процестерін автоматтандыру үшін заманауи құралдар мен платформаларды пайдаланыңыз.",
                nameEng: "Use modern tools and platforms to automate threat detection processes."
            },
            {
                nameRu: "Разрабатывать и внедрять стратегии предотвращения угроз.",
                nameKz: "Қауіптердің алдын алу стратегияларын әзірлеу және енгізу.",
                nameEng: "Develop and implement threat prevention strategies."
            },
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Сетевая безопасность и анализ трафика",
                    nameKz: "Желі қауіпсіздігі және трафикті талдау",
                    nameEng: "Network Security and Traffic Analysis"
                },
                desc: {
                    nameRu: "Данная дисциплина изучает сетевые протокола, методы анализа сетевого трафика и детектирования аномалий. А также работу с инструментами для мониторинга и анализа сетевой активности.",
                    nameKz: "Бұл пән желілік протоколдарды, желілік трафикті талдау және ауытқуларды анықтау әдістерін зерттейді. Сондай-ақ желі белсенділігін бақылау және талдау құралдарымен жұмыс істеу.",
                    nameEng: "This discipline studies network protocols, methods for analyzing network traffic, and detecting anomalies. It also covers the use of tools for monitoring and analyzing network activity."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК1"
            },
            {
                name: {
                    nameRu: "Использование SIEM систем",
                    nameKz: "SIEM жүйелерін қолдану",
                    nameEng: "Using SIEM Systems"
                },
                desc: {
                    nameRu: "Данная дисциплина изучает системы управления информационной безопасностью и событийными журналами (SIEM), их роль в обнаружении и реагировании на угрозы. Практические навыки настройки и использования SIEM систем.",
                    nameKz: "Бұл пән ақпараттық қауіпсіздік және оқиғаларды басқару жүйелерін (SIEM) және олардың қауіптерді анықтау және әрекет етудегі рөлін зерттейді. SIEM жүйелерін орнату және пайдалану бойынша практикалық дағдылар.",
                    nameEng: "This discipline covers Security Information and Event Management (SIEM) systems, their role in threat detection and response, and provides practical skills in configuring and using SIEM systems."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК2"
            },
            {
                name: {
                    nameRu: "Техники и методики Threat Hunting",
                    nameKz: "Қауіпті аң аулау әдістері мен әдістері",
                    nameEng: "Techniques and Methods of Threat Hunting"
                },
                desc: {
                    nameRu: "Основной целью дисциплины является погружение в различные методики и техники threat hunting для проактивного обнаружения и анализа угроз. Включает практические занятия по использованию инструментов и разработке сценариев поиска угроз.",
                    nameKz: "Пәннің негізгі мақсаты қауіптерді алдын ала анықтау және талдау үшін әртүрлі қауіптерді аулау әдістері мен әдістеріне сүңгу болып табылады. Құралдарды пайдалану және қауіпті аңшылық сценарийлерін әзірлеу бойынша практикалық оқытуды қамтиды.",
                    nameEng: "The main objective of this discipline is to delve into various threat hunting techniques and methods for proactive threat detection and analysis. It includes practical exercises on using tools and developing threat hunting scenarios."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК3, ПК4"
            },
        ]
    },
    {
        id: 15,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        groupEP: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        microQEP: {
            nameRu: "COMPUTER FORENSICS ANALYST (автономная)",
            nameKz: "COMPUTER FORENSICS ANALYST",
            nameEng: "COMPUTER FORENSICS ANALYST"
        },
        partnerOrg: {
            nameRu: "ТОО «Communications Kazakhstan»",
            nameKz: "«Communications Kazakhstan» ЖШС",
            nameEng: "Communications Kazakhstan LLP"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 10,
        regNumber: "MCCE-2024/0015",
        regDate: "16.08.2024",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Данная программа нацелена на изучение современных подходов по сбору цифровых следов без потерь и детальному анализу. В процессе обучения слушатели освоят приёмы правильного снятия образа с зараженных хостов, научатся правильно анализировать цифровые следы из зараженных систем и при сетевых атаках.",
            nameKz: "Бұл бағдарлама цифрлық іздерді жоғалтпай және егжей-тегжейлі талдаусыз жинаудың заманауи тәсілдерін зерттеуге бағытталған. Оқыту процесінде студенттер вирус жұққан хосттардан кескіндерді дұрыс жою әдістерін меңгереді және вирус жұққан жүйелерден және желілік шабуылдар кезінде цифрлық іздерді дұрыс талдауды үйренеді.",
            nameEng: "This program focuses on the study of modern approaches to non-destructive digital evidence collection and detailed analysis. Throughout the program, participants will learn proper techniques for acquiring images from infected hosts, as well as analyzing digital traces from infected systems and during network attacks."
        },
        goalEPMQ: {
            nameRu: "Исследование современных методов компьютерной криминалистики, которые позволят самостоятельно выполнять снятие образа системы, осуществлять полный анализ исследуемой системы, и составлять аналитический отчет по результатам исследования",
            nameKz: "Жүйенің кескінін түсіруді өз бетінше орындауға, зерттелетін жүйеге толық талдау жүргізуге және зерттеу нәтижелері бойынша аналитикалық есеп жасауға мүмкіндік беретін компьютерлік криминалистиканың заманауи әдістерін зерттеу.",
            nameEng: "To explore contemporary methods of computer forensics that enable independent system imaging, complete system analysis, and the preparation of analytical reports based on research findings."
        },
        tasksEPMQ: [
            {
                nameRu: "Подготовка специалистов по направлению «компьютерная криминалистика»;",
                nameKz: "«Компьютерлік сот сараптамасы» саласында мамандарды даярлау;",
                nameEng: "Training specialists in the field of digital forensics."
            },
            {
                nameRu: "Формирование теоретических и практических знаний по анализу цифровых следов;",
                nameKz: "Цифрлық іздерді талдау бойынша теориялық және практикалық білімдерін қалыптастыру;",
                nameEng: "Formation of theoretical and practical knowledge in digital evidence analysis."
            },
            {
                nameRu: "Выработка практических навыков по работе с инструментами сбору и анализу цифровых следов.",
                nameKz: "Цифрлық іздерді жинау және талдау құралдарымен жұмыс істеудің практикалық дағдыларын дамыту.",
                nameEng: "Development of practical skills in working with tools for collecting and analyzing digital evidence."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Выполнять сбор цифровых следов.",
                nameKz: "Сандық іздерді жинаңыз.",
                nameEng: "Perform digital evidence collection."
            },
            {
                nameRu: "Анализировать цифровые следы.",
                nameKz: "Цифрлық іздерді талдау.",
                nameEng: "Analyze digital evidence."
            },
            {
                nameRu: "Составлять отчет по криминалистике по результатам исследования.",
                nameKz: "Зерттеу нәтижелері бойынша сот сараптамасының қорытындысын дайындаңыз.",
                nameEng: "Prepare a forensic report based on the investigation results."
            },
            {
                nameRu: "Анализировать лог-файлы системы.",
                nameKz: "Жүйе журналының файлдарын талдау.",
                nameEng: "Analyze system log files."
            },
            {
                nameRu: "Извлекать и анализировать логи из сетевых устройств.",
                nameKz: "Желілік құрылғылардан журналдарды шығару және талдау.",
                nameEng: "Extract and analyze logs from network devices."
            },
            {
                nameRu: "Управлять основными компонентами системы.",
                nameKz: "Жүйенің негізгі компоненттерін басқару.",
                nameEng: "Manage core system components."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Внутреннее устройство операционных систем",
                    nameKz: "Операциялық жүйелердің ішкі құрылымы",
                    nameEng: "Internal Structure of Operating Systems"
                },
                desc: {
                    nameRu: "Внутреннее устройство операционных систем обеспечивает управление ресурсами компьютера, включая процессор, память, устройства ввода-вывода и файловую систему. Это включает планирование задач, управление памятью, взаимодействие с железом и обеспечение безопасности. Операционные системы также предоставляют интерфейс для взаимодействия пользователя с компьютером.",
                    nameKz: "Операциялық жүйелердің ішкі құрылымы компьютер ресурстарын басқаруды қамтамасыз етеді, оның ішінде процессор, жад, енгізу/шығару құрылғылары және файлдық жүйе. Бұған тапсырмаларды жоспарлау, жадты басқару, аппараттық құралдармен әрекеттесу және қауіпсіздік кіреді. Операциялық жүйелер сонымен қатар пайдаланушының компьютермен өзара әрекеттесуі үшін интерфейсті қамтамасыз етеді.",
                    nameEng: "This course explores the management of computer resources such as the processor, memory, input/output devices, and file systems within operating systems. Topics include task scheduling, memory management, hardware interaction, security measures, and user-computer interaction interfaces."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК4, ПК5"
            },
            {
                name: {
                    nameRu: "Компьютерные сети",
                    nameKz: "Компьютерлік желілер",
                    nameEng: "Computer Networks"
                },
                desc: {
                    nameRu: "Данная дисциплина изучает принципы проектирования, управления и анализа сетей передачи данных. Включает основы сетевых технологий, протоколов и архитектур, таких как TCP/IP, Ethernet, Wi-Fi. Обучение включает настройку сетевого оборудования, обеспечение безопасности сетей и оптимизацию производительности.",
                    nameKz: "Бұл пән деректер желілерін жобалау, басқару және талдау принциптерін зерттейді. TCP/IP, Ethernet, Wi-Fi сияқты желілік технологиялардың, хаттамалардың және архитектураның негіздерін қамтиды. Оқыту желілік жабдықты конфигурациялауды, желілерді қорғауды және өнімділікті оңтайландыруды қамтиды.",
                    nameEng: "This discipline covers the principles of designing, managing, and analyzing data transmission networks. It includes fundamentals of network technologies, protocols, and architectures like TCP/IP, Ethernet, and Wi-Fi. Training encompasses configuring network equipment, ensuring network security, and optimizing performance."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК6"
            },
            {
                name: {
                    nameRu: "Компьютерная криминалистика",
                    nameKz: "Компьютерлік криминалистика",
                    nameEng: "Digital Forensics"
                },
                desc: {
                    nameRu: "Основной целью дисциплины является овладение навыков для работы с инструментами сбора цифровых следов, анализа доказательств с хоста, памяти системы, сетевых цифровых следов, и лог-файлов. И составление аналитического отчета по результатам исследования.",
                    nameKz: "Пәннің негізгі мақсаты – сандық іздерді жинау, хосттан, жүйелік жадтан, желілік сандық іздер мен журнал файлдарынан алынған дәлелдемелерді талдауға арналған құралдармен жұмыс істеу дағдыларын меңгеру. Және зерттеу нәтижелері бойынша аналитикалық есеп құрастыру.",
                    nameEng: "The primary objective is to develop skills in using tools for collecting digital evidence, analyzing host and system memory evidence, network digital traces, and log files. Students also learn to compile analytical reports based on investigation outcomes."
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3"
            },
        ]
    },
    {
        id: 16,
        educationField: {
            nameRu: "Информационно-коммуникационные технологии",
            nameKz: "Ақпараттық-коммуникациялық технологиялар",
            nameEng: "Information and communication technologies",
            code: "6B06 "
        },
        trainingDirection: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        groupEP: {
            nameRu: "Информационная безопасность",
            nameKz: "Ақпараттық қауіпсіздік",
            nameEng: "Information Security",
            code: ""
        },
        microQEP: {
            nameRu: "MALWARE ANALYST (автономная)",
            nameKz: "MALWARE ANALYST",
            nameEng: "MALWARE ANALYST"
        },
        partnerOrg: {
            nameRu: "ТОО «Communications Kazakhstan»",
            nameKz: "«Communications Kazakhstan» ЖШС",
            nameEng: "Communications Kazakhstan LLP"
        },
        licenceNumber: "KZ67LAA00019559",
        creditNum: 10,
        regNumber: "MCCE-2024/0016",
        regDate: "16.08.2024",
        learnLanguage: {
            nameRu: "русский, английский",
            nameKz: "орыс, ағылшын",
            nameEng: "Russian, English"
        },
        mainDirectionEP: {
            nameRu: "Программа направлена на подготовку специалистов в области исследования вредоносного кода, на получение компетенций, необходимых для выполнения задач по одному из актуальных направлений информационной безопасности в мире. Программа охватывает все основные понятия базового и продвинутого статического и динамического анализа, разбор инструментов по анализу вредоносных файлов, и  подходов по нейтрализации вредоносной активности. Слушатели познакомятся со всеми основными методами и техниками исследования вредоносного кода, освоят приёмы обхода алгоритмов противодействия анализу вредоносных файлов.",
            nameKz: "Бағдарлама зиянды кодты зерттеу саласында мамандарды даярлауға, әлемдегі ақпараттық қауіпсіздіктің қазіргі бағыттарының бірінде тапсырмаларды орындауға қажетті құзыреттерді алуға бағытталған. Бағдарлама негізгі және кеңейтілген статикалық және динамикалық талдаудың барлық негізгі тұжырымдамаларын, зиянды файлдарды талдау құралдарын талдауды және зиянды әрекетті бейтараптандыру тәсілдерін қамтиды. Студенттер зиянды кодты зерттеудің барлық негізгі әдістерімен және әдістерімен таныс болады және зиянды файлдарды талдауға қарсы алгоритмдерді айналып өту әдістерін меңгереді.",
            nameEng: "The program aims to train specialists in the field of malicious code research, equipping them with competencies necessary for tasks in one of the most crucial areas of information security worldwide. The program covers fundamental and advanced concepts of static and dynamic analysis, dissection of tools for malicious file analysis, and approaches to neutralizing malicious activity. Participants will familiarize themselves with all major methods and techniques of malicious code investigation, mastering techniques to bypass algorithms designed to hinder analysis of malicious files."
        },
        goalEPMQ: {
            nameRu: "Формирование навыков по анализу файлов на наличие уязвимостей и исследованию вредоносного ПО",
            nameKz: "осалдықтар үшін файлдарды талдау және зиянды бағдарламаларды зерттеу дағдыларын қалыптастыру.",
            nameEng: "To develop skills in analyzing files for vulnerabilities and researching malicious software."
        },
        tasksEPMQ: [
            {
                nameRu: "Подготовка специалистов по направлению исследование вредоносного кода;",
                nameKz: "зиянды кодты зерттеу саласында мамандарды дайындау;",
                nameEng: "Preparation of specialists in the field of malware analysis."
            },
            {
                nameRu: "Формирование теоретических и практических знаний по изучению вредоносных файлов;",
                nameKz: "Зиянды файлдарды зерттеу бойынша теориялық және практикалық білімді қалыптастыру;",
                nameEng: "Formation of theoretical and practical knowledge in studying malicious files."
            },
            {
                nameRu: "Выработка практических навыков по работе с инструментами базового, продвинутого статического и динамического анализа.",
                nameKz: "Негізгі, кеңейтілген статикалық және динамикалық талдау құралдарымен жұмыс істеудің практикалық дағдыларын дамыту.",
                nameEng: "Development of practical skills in using tools for basic and advanced static and dynamic analysis."
            }
        ],
        formLearnResult: [
            {
                nameRu: "Выполнять базовый динамический и статический анализы для сбора основных сведений о вредоносном файле.",
                nameKz: "Зиянды файл туралы негізгі ақпаратты жинау үшін негізгі динамикалық және статикалық талдауды орындаңыз.",
                nameEng: "Perform basic dynamic and static analyses to gather fundamental information about malicious files."
            },
            {
                nameRu: "Выполнять отладку и продвинутый статический анализ вредоносного ПО.",
                nameKz: "Зиянды бағдарламаны жөндеу және кеңейтілген статикалық талдауды орындаңыз.",
                nameEng: "Perform debugging and advanced static analysis of malicious software."
            },
            {
                nameRu: "Определять скрытый запуск вредоносного ПО.",
                nameKz: "Жасырын зиянды бағдарламаларды іске қосуды анықтаңыз.",
                nameEng: "Identify hidden execution of malicious software. "
            },
            {
                nameRu: "Распознавать тип упаковщика и выполнять распаковку.",
                nameKz: "Пакер түрін тану және орамнан шығаруды орындаңыз.",
                nameEng: "Recognize packer types and perform unpacking."
            },
            {
                nameRu: "Противодействовать методам антидизассемблирования и антиотладки.",
                nameKz: "Бөлшектеу және жөндеуге қарсы әдістерге қарсы әрекет етіңіз.",
                nameEng: "Counteract anti-disassembly and anti-debugging methods."
            },
            {
                nameRu: "Анализировать макросные вредоносные программы.",
                nameKz: "Макро зиянды бағдарламаларды талдаңыз.",
                nameEng: "Analyze macro-based malicious programs. "
            },
            {
                nameRu: "Анализировать .NET ВПО.",
                nameKz: "NET зиянды бағдарламалық құралын талдаңыз.",
                nameEng: "Analyze .NET malware."
            },
            {
                nameRu: "Создавать и управлять процессами и потоками.",
                nameKz: "Процестер мен ағындарды құру және басқару.",
                nameEng: "Create and manage processes and threads."
            },
            {
                nameRu: "Управлять памятью компьютера.",
                nameKz: "Компьютер жадын басқару.",
                nameEng: "Manage computer memory. "
            },
            {
                nameRu: "Взаимодействовать с системой ввода/вывода компьютера.",
                nameKz: "Компьютердің енгізу/шығару жүйесімен әрекеттесу.",
                nameEng: "Interact with computer input/output system. "
            },
            {
                nameRu: "Работать с элементами системы безопасности.",
                nameKz: "Қауіпсіздік жүйесінің құрамдас бөліктерімен жұмыс.",
                nameEng: "Work with elements of computer security system."
            }
        ],
        disciplines: [
            {
                name: {
                    nameRu: "Архитектура ОС Windows",
                    nameKz: "Windows ОЖ архитектурасы",
                    nameEng: "Windows OS Architecture"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у обучающихся теоретических знаний и практических навыков по работе с основными компонентами ОС Windows, такими как процессы, потоки, дескрипторы, мьютексы и система безопасности.",
                    nameKz: "Пәннің мақсаты студенттердің Windows ОЖ-нің процестер, ағындар, дескрипторлар, мутекстер және қауіпсіздік жүйесі сияқты негізгі компоненттерімен жұмыс істеуде теориялық білімдерін және практикалық дағдыларын дамыту болып табылады.",
                    nameEng: "This course aims to impart theoretical knowledge and practical skills in the core components of Windows OS, including processes, threads, descriptors, mutexes, and security systems"
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК9, ПК10"
            },
            {
                name: {
                    nameRu: "Системное программирование",
                    nameKz: "Жүйелік бағдарламалау",
                    nameEng: "System Programming"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у обучающихся теоретических знаний и практических навыков по системному программированию по технологии Windows API. Будут рассмотрены основные функции по работе с файловой системы, реестром, процессом, потоком и сетью, которые используются злоумышленниками при написании вредоносного кода.",
                    nameKz: "Пәннің мақсаты студенттердің Windows API технологиясын қолдану арқылы жүйелік бағдарламалау бойынша теориялық білімдерін және практикалық дағдыларын дамыту болып табылады. Зиянды кодты жазу кезінде шабуылдаушылар пайдаланатын файлдық жүйемен, тізіліммен, процесспен, ағынмен және желімен жұмыс істеудің негізгі функциялары талқыланады.",
                    nameEng: "This course aims to educate students in system programming using Windows API technology, covering essential functions related to file systems, registry, processes, threads, and networking, pertinent to malicious code development."
                },
                creditNum: 2,
                acaHrNum: 60,
                codes: "ПК7, ПК8"
            },
            {
                name: {
                    nameRu: "Исследование вредоносного кода",
                    nameKz: "Зиянды кодты зерттеу",
                    nameEng: "Malware Analysis"
                },
                desc: {
                    nameRu: "Целью дисциплины является формирование у обучающихся теоретических знаний и практических навыков по исследованию вредоносного кода, освоение продвинутых методов статического и динамического анализа вредоносных файлов, а также овладение приёмов обхода современных методов по анализу противодействия, используемых злоумышленниками.",
                    nameKz: "Пәннің мақсаты студенттерде зиянды кодты зерттеуде теориялық білім мен практикалық дағдыларды дамыту, зиянды файлдарды статикалық және динамикалық талдаудың озық әдістерін меңгеру, сонымен қатар шабуылдаушылар қолданатын заманауи қарсы шараларды талдау әдістерін айналып өту әдістерін меңгеру болып табылады.",
                    nameEng: "This course aims to provide theoretical insights and practical skills in advanced methods of static and dynamic analysis of malicious code, along with techniques to circumvent modern anti-analysis measures employed by adversaries"
                },
                creditNum: 5,
                acaHrNum: 150,
                codes: "ПК1, ПК2, ПК3, ПК4, ПК5, ПК6"
            }
        ]
    },
]